<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';
import laborantesEvento from './eventolaborantes.vue';
import asistentesQrEvento from './asistentes_qr_evento.vue';
import asistentesCdEvento from './asistentes_cd_evento.vue';
import pdf from 'vue-pdf';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, laborantesEvento, asistentesQrEvento, asistentesCdEvento, pdf },
    data() {
        return {
            title: "Eventos",
            items: [
                {
                text: "Configuración",
                href: "/"
                },
                {
                text: "Eventos",
                active: true
                }
            ],
            datoseventos:[],
            eventos:[],
            eventoseleccionada: [],                       //alumna seleccionada en el buscador
            eventoid_seleccion: [],                       //id alumna
            eventoid_seleccion1: [],                       //id alumna
            habilitar_boton: false,
            editing: false,
            originalevento:'',
            tipos_gastos:['Transporte local/Nacional','Alimentos/bebidas reuniones','Peaje y estacionamiento','Gasolina','Materiales de oficina','Hospedaje','Pasajes bus/tren/avion'],
            cajasChicas: [],
            tipos:[],
            subtipos:[],
            cursos: ['Primero Medio', 'Segundo Medio', 'Tercero Medio', 'Cuarto Medio', 'Egresado'],
            emailError:'',
            phoneerror:'',
            copiado:false,
            isLoading: false,
            loadingTitle: 'Cargando...',
            loadingSubtitle: 'Esto podría tardar unos segundos.',
            isSendingPreview: false,
            isSendingEvaluacionPrueba: false,
            isOpeningEncuesta: false,
            colegios:[],
            todos_colegios:[],
            usuarios:[],
            subtiposfilter:[],
            estados:['Aprobado','Cerrado','Cancelado'],
            estado:'',
            showUploadAsistentes: false,
            selectedAsistentesFile: null,
            asistentesFileKey: 0,
            showGastoForm: false,
            gasto: {
                tipo: null,
                monto: '$0',
                imagen: null,
                caja_chica_id: ''
            },
            tipoArchivo: '',
            imagenminiatura: '',
            direccion: '',
            direccionMiniaturaS3: '',
            extension: '',
            miniaturaS3Extension: '',
            previewObjectUrl: '',
            archivoDisponible: true,
            archivoMensaje: '',
            cambiar: false,
            pagosLaborantesEvento: [],
            comentariosEvento: [],
            digitalizadosEvento: [],
            comentarioEventoNuevo: '',
            guardandoComentarioEvento: false,
            guardandoGasto: false,
            valor_editar:{
                tipo: null,
                monto: '$0',
                imagen: null,
                caja_chica_id: ''}
        };
    },
    computed:{
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.eventoid_seleccion.correo_notificaciones);
        },
        pagosLaborantesPagados() {
            return (this.pagosLaborantesEvento || []).filter(item => item.estado === 'Pagado');
        },
        gastosEvento() {
            if (!this.eventoid_seleccion1 || !Array.isArray(this.eventoid_seleccion1.gastos)) {
                return [];
            }
            return this.eventoid_seleccion1.gastos;
        },
        digitalizadosEventoLista() {
            if (!this.eventoid_seleccion1 || !Array.isArray(this.eventoid_seleccion1.digitalizados)) {
                return [];
            }
            return this.eventoid_seleccion1.digitalizados;
        },
        esDiaInicioEvento() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.fecha_inicio) {
                return false;
            }
            const fechaInicio = String(this.eventoid_seleccion1.fecha_inicio).slice(0, 10);
            const hoy = new Date();
            const hoyFormato = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
            return hoyFormato >= fechaInicio;
        },
        asistentesYaCargados() {
            return !!(this.eventoid_seleccion1 && Array.isArray(this.eventoid_seleccion1.asistentes) && this.eventoid_seleccion1.asistentes.length);
        },
        asistentesMarcadosReenvio() {
            if (!this.eventoid_seleccion1 || !Array.isArray(this.eventoid_seleccion1.asistentes)) {
                return 0;
            }

            return this.eventoid_seleccion1.asistentes.filter((asistente) => !!asistente.marcado_reenvio_crm).length;
        },
        asistentesPendientesDisponibles() {
            if (!this.eventoid_seleccion1 || !Array.isArray(this.eventoid_seleccion1.asistentes)) {
                return 0;
            }

            return this.eventoid_seleccion1.asistentes.filter((asistente) => {
                const estado = asistente && asistente.estado_crm ? asistente.estado_crm : 'pendiente_envio';
                return ['pendiente_envio', 'pendiente_reenvio', 'reenvio_programado'].includes(estado)
                    && !asistente.marcado_reenvio_crm;
            }).length;
        },
        asistentesConErrorDisponibles() {
            if (!this.eventoid_seleccion1 || !Array.isArray(this.eventoid_seleccion1.asistentes)) {
                return 0;
            }

            return this.eventoid_seleccion1.asistentes.filter((asistente) => {
                return asistente
                    && asistente.estado_crm === 'error_envio'
                    && !asistente.marcado_reenvio_crm;
            }).length;
        },
        puedeGestionarAsistentes() {
            return !!(this.user && this.user.rol === 'Admin');
        },
        puedeVerAsistentesQr() {
            return !!(this.user && this.user.rol !== 'Laborante');
        },
        comentarioEventoCharsRestantes() {
            const max = 2000;
            const actual = (this.comentarioEventoNuevo || '').length;
            return max - actual;
        },
        mostrarMiniaturaComprobanteS3() {
            return !!(
                this.archivoDisponible
                && this.user
                && Number(this.user.id) === 1
                && this.direccionMiniaturaS3
            );
        },
        cajasChicasOptions() {
            return [
                { value: '', text: 'Sin caja chica' },
                ...(this.cajasChicas || []).map((caja) => ({
                    value: String(caja.id),
                    text: caja.sede ? `${caja.nombre} (${caja.sede})` : caja.nombre,
                })),
            ];
        },
        coordinadorEventoInfo() {
            const evento = this.eventoid_seleccion1 || {};
            const coordinadorRaw = this.valorLegible(evento.coordinador_evento || '');
            const usuario = this.obtenerUsuarioCoordinador(evento, coordinadorRaw);
            const rutRawNormalizado = this.normalizarRut(coordinadorRaw);

            const nombre = usuario && usuario.name
                ? usuario.name
                : (rutRawNormalizado ? '' : coordinadorRaw);

            const rut = usuario && usuario.rut
                ? usuario.rut
                : (rutRawNormalizado ? coordinadorRaw : '');

            return {
                nombre: nombre || coordinadorRaw || '-',
                rut: rut || '',
            };
        }
    },
    methods:{
        normalizarRut(valor) {
            if (!valor) return '';

            const texto = valor.toString().trim().toUpperCase();
            const sinPuntos = texto.replace(/\./g, '').replace(/\s+/g, '');
            const soloRut = sinPuntos.replace(/[^0-9K-]/g, '');

            return soloRut;
        },
        normalizarTextoSimple(valor) {
            return (valor || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim();
        },
        obtenerUsuarioCoordinador(evento, coordinadorRaw) {
            if (!Array.isArray(this.usuarios) || !this.usuarios.length) {
                return null;
            }

            const userId = Number(evento && evento.user_id ? evento.user_id : 0);
            if (userId) {
                const porId = this.usuarios.find((u) => Number(u.id) === userId);
                if (porId) return porId;
            }

            const rutNormalizado = this.normalizarRut(coordinadorRaw);
            if (rutNormalizado) {
                const porRut = this.usuarios.find((u) => this.normalizarRut(u.rut) === rutNormalizado);
                if (porRut) return porRut;
            }

            const nombreNormalizado = this.normalizarTextoSimple(coordinadorRaw);
            if (nombreNormalizado) {
                const porNombre = this.usuarios.find((u) => this.normalizarTextoSimple(u.name) === nombreNormalizado);
                if (porNombre) return porNombre;
            }

            return null;
        },
        crmEstadoBadge(estado) {
            const estadoNormalizado = estado || 'pendiente_envio';

            if (estadoNormalizado === 'enviado_ok') return 'success';
            if (estadoNormalizado === 'duplicado') return 'warning';
            if (estadoNormalizado === 'error_envio') return 'danger';
            if (estadoNormalizado === 'reenvio_programado' || estadoNormalizado === 'pendiente_reenvio') return 'info';
            return 'secondary';
        },
        crmEstadoTexto(estado) {
            const estadoNormalizado = estado || 'pendiente_envio';

            if (estadoNormalizado === 'enviado_ok') return 'Enviado OK';
            if (estadoNormalizado === 'duplicado') return 'Duplicado CRM';
            if (estadoNormalizado === 'error_envio') return 'Error de envio';
            if (estadoNormalizado === 'reenvio_programado') return 'Reenvío programado';
            if (estadoNormalizado === 'pendiente_reenvio') return 'Pendiente reenvío';
            return 'Pendiente';
        },
        crmEstadoTooltip(asistente) {
            if (!asistente || asistente.estado_crm !== 'error_envio') {
                return '';
            }

            return asistente.ultimo_error_crm || 'No fue posible enviar el registro al CRM.';
        },
        puedeMarcarReenvio(asistente) {
            const estado = asistente && asistente.estado_crm ? asistente.estado_crm : 'pendiente_envio';
            return ['pendiente_envio', 'pendiente_reenvio', 'reenvio_programado', 'error_envio'].includes(estado);
        },
        validateEmail() {
            if (this.eventoid_seleccion.correo_notificaciones && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.eventoid_seleccion.telefono_notificaciones.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.eventoid_seleccion.telefono_notificaciones = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.eventoid_seleccion.telefono_notificaciones.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        modificar_id(eventoseleccionada) {
            this.datoseventos.forEach(element => {
                if (element.nombre == eventoseleccionada) {
                    this.eventoid_seleccion = element.id;
                    //console.log(element.nombre);
                    this.habilitar_boton = true
                }
            });
        },
        toggleEdit() {
            this.originalevento = { ...this.eventoid_seleccion };
            if (this.editing) {
                if(this.validacion()){
                    this.isLoading=true;

                    const normalizarUsuario = (valor) => {
                        const item = Array.isArray(valor) ? valor[0] : valor;
                        if (!item) return null;
                        if (typeof item === 'object') return item;
                        if (typeof item === 'string') return { name: item };
                        return null;
                    };

                    const obtenerNombreUsuario = (valor) => {
                        const usuario = normalizarUsuario(valor);
                        return usuario ? (usuario.name || '') : '';
                    };

                    const coordinadorSeleccionado = Array.isArray(this.eventoid_seleccion.coordinador_evento)
                        ? this.eventoid_seleccion.coordinador_evento[0]
                        : this.eventoid_seleccion.coordinador_evento;
                    const propietarioSeleccionado = Array.isArray(this.eventoid_seleccion.propietario)
                        ? this.eventoid_seleccion.propietario[0]
                        : this.eventoid_seleccion.propietario;
                    const estadoSeleccionado = Array.isArray(this.eventoid_seleccion.estado_actividad)
                        ? this.eventoid_seleccion.estado_actividad[0]
                        : this.eventoid_seleccion.estado_actividad;
                    this.originalevento.nombre_difusion = this.eventoid_seleccion.nombre_difusion;
                    this.originalevento.fecha_inicio = this.eventoid_seleccion.fecha_inicio;
                    this.originalevento.fecha_termino = this.eventoid_seleccion.fecha_termino;
                    this.originalevento.tipo = this.eventoid_seleccion.tipo.codigo;
                    this.originalevento.tipo_codigo = this.eventoid_seleccion.tipo.codigo;
                    this.originalevento.subtipo = this.eventoid_seleccion.subtipo.codigo;
                    this.originalevento.subtipo_codigo = this.eventoid_seleccion.subtipo.codigo;
                    this.originalevento.curso_multi = JSON.stringify(this.eventoid_seleccion.curso_multi);
                    this.originalevento.correo_notificaciones = this.eventoid_seleccion.correo_notificaciones;
                    this.originalevento.telefono_notificaciones = this.eventoid_seleccion.telefono_notificaciones;
                    this.originalevento.titulo_landing_inscripcion = this.eventoid_seleccion.titulo_landing_inscripcion;
                    this.originalevento.comentario_nombre_evento = (this.eventoid_seleccion.comentario_nombre_evento || '').toString().trim();
                    this.originalevento.user_id = (normalizarUsuario(coordinadorSeleccionado) && normalizarUsuario(coordinadorSeleccionado).id)
                        ? normalizarUsuario(coordinadorSeleccionado).id
                        : null;
                    this.originalevento.coordinador_evento = (normalizarUsuario(coordinadorSeleccionado) && normalizarUsuario(coordinadorSeleccionado).name)
                        ? normalizarUsuario(coordinadorSeleccionado).name
                        : '';
                    this.originalevento.coordinador = obtenerNombreUsuario(coordinadorSeleccionado);
                    this.originalevento.rbd_colegio = this.eventoid_seleccion.colegio_datos.rbd;
                    this.originalevento.colegio = this.eventoid_seleccion.colegio_datos.nombre;
                    this.originalevento.sede_asociada = (normalizarUsuario(propietarioSeleccionado) && normalizarUsuario(propietarioSeleccionado).sede)
                        ? normalizarUsuario(propietarioSeleccionado).sede
                        : this.eventoid_seleccion.sede_asociada;
                    this.originalevento.propietario_colegio = this.eventoid_seleccion.colegio_datos.propietario;
                    this.originalevento.propietario = obtenerNombreUsuario(propietarioSeleccionado);
                    this.originalevento.estado_actividad = estadoSeleccionado && estadoSeleccionado.nombre
                        ? estadoSeleccionado.nombre
                        : (typeof estadoSeleccionado === 'string' ? estadoSeleccionado : '');
                    axios.post('/api/editar_evento',this.originalevento).then(res=>{
                        if(res.data.estado){
                            //this.sucursal=res.data.sucursal
                            //window.location.reload();
                            const eventoActualizado = res.data.evento || {};
                            this.eventoid_seleccion = {
                                ...this.eventoid_seleccion,
                                ...eventoActualizado,
                            };
                            this.eventoid_seleccion1 = {
                                ...this.eventoid_seleccion1,
                                ...eventoActualizado,
                            };
                            this.select1();
                            this.select();

                            if (Array.isArray(this.eventos) && this.eventoid_seleccion1 && this.eventoid_seleccion1.id) {
                                this.eventos = this.eventos.map((evento) => (
                                    evento && evento.id === this.eventoid_seleccion1.id
                                        ? { ...evento, ...eventoActualizado }
                                        : evento
                                ));
                            }

                            if (this.eventoseleccionada && this.eventoseleccionada.id === this.eventoid_seleccion1.id) {
                                this.eventoseleccionada = {
                                    ...this.eventoseleccionada,
                                    ...eventoActualizado,
                                };
                            }

                            Swal.fire({
                                //position: "top-end",
                                icon: "success",
                                title: res.data.mensaje,
                                text: '',
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }else{
                            Swal.fire({
                                //position: "top-end",
                                icon: "warning",
                                title: res.data.mensaje,
                                text: '',
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                        this.isLoading=false
                    }).catch(() => {
                        this.isLoading=false
                        Swal.fire({
                            icon: "error",
                            title: "No se guardaron los cambios",
                            text: "Ocurrió un error al editar el evento.",
                            timer: 3500,
                            showConfirmButton: false
                        });
                    })
                }
            }
            this.editing = !this.editing;
        },
        enviarPreviewCorreoEvento(tipo = 'creacion_evento') {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                return;
            }

            this.isSendingPreview = true;

            axios.post('/api/enviar_preview_correo_evento', {
                evento_id: this.eventoid_seleccion1.id,
                tipo,
            }).then((response) => {
                Swal.fire({
                    icon: response.data.estado ? 'success' : 'warning',
                    title: response.data.mensaje,
                    showConfirmButton: false,
                    timer: 4000,
                });
            }).catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'No se pudo enviar la vista previa',
                    showConfirmButton: false,
                    timer: 4000,
                });
            }).finally(() => {
                this.isSendingPreview = false;
            });
        },
        enviarCorreoEvaluacionActividadPrueba() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                return;
            }

            this.isSendingEvaluacionPrueba = true;

            axios.post('/api/enviar_correo_evaluacion_actividad_prueba', {
                evento_id: this.eventoid_seleccion1.id,
            }).then((response) => {
                Swal.fire({
                    icon: response.data.estado ? 'success' : 'warning',
                    title: response.data.mensaje,
                    showConfirmButton: false,
                    timer: 4500,
                });
            }).catch((error) => {
                const mensaje = (error && error.response && error.response.data && error.response.data.mensaje)
                    ? error.response.data.mensaje
                    : 'No se pudo enviar correo de prueba';
                Swal.fire({
                    icon: 'error',
                    title: mensaje,
                    showConfirmButton: false,
                    timer: 4500,
                });
            }).finally(() => {
                this.isSendingEvaluacionPrueba = false;
            });
        },
        abrirLinkEncuestaActividad() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                return;
            }

            const rbdColegio = (this.eventoid_seleccion1.rbd_colegio || '').toString().trim();
            const colegio = (this.eventoid_seleccion1.colegio || '').toString().trim().toUpperCase();
            const eventoSinColegio = !rbdColegio || rbdColegio === '-' || colegio === 'SIN COLEGIO';

            this.isOpeningEncuesta = true;

            axios.post('/api/obtener_link_encuesta_actividad', {
                evento_id: this.eventoid_seleccion1.id,
            }).then((response) => {
                if (response.data && response.data.estado && response.data.link) {
                    window.open(response.data.link, '_blank');
                    return;
                }

                Swal.fire({
                    icon: 'warning',
                    title: response.data.mensaje || (eventoSinColegio ? 'No se pudo obtener el link de encuesta porque no hay colegio asociado' : 'No se pudo obtener el link de encuesta'),
                    showConfirmButton: false,
                    timer: 4500,
                });
            }).catch((error) => {
                const mensaje = (error && error.response && error.response.data && error.response.data.mensaje)
                    ? error.response.data.mensaje
                    : (error && error.response && error.response.status
                        ? `No se pudo obtener el link de encuesta (HTTP ${error.response.status})`
                        : (eventoSinColegio ? 'No se pudo obtener el link de encuesta porque no hay colegio asociado' : 'No se pudo obtener el link de encuesta'));
                Swal.fire({
                    icon: 'error',
                    title: mensaje,
                    showConfirmButton: false,
                    timer: 4500,
                });
            }).finally(() => {
                this.isOpeningEncuesta = false;
            });
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        handleKeydown(event) {
            // Verifica si la tecla presionada es Enter o Enter del teclado numérico
            if (event.key == "Enter" || event.code == "Enter" || event.keyCode == 13) {
                event.preventDefault(); // Previene comportamientos predeterminados (como un submit en formularios)
                this.consultarEvento();
            }
        },
        labelEvento(evento) {
            const nombre = (evento?.nombre_difusion || '').toString().trim();
            const comentario = (evento?.comentario_nombre_evento || '').toString().trim();
            const nombreConComentario = comentario ? `${nombre} (${comentario})` : nombre;
            return `${evento.codigo} - ${nombreConComentario}`;
        },
        onSelectEvento(evento) {
            // console.log('Evento seleccionado:', evento);
            this.consultarEvento();
        },
        onEnterSelectEvento() {
            this.consultarEvento();
        },
        onSelectColegio(){
            this.eventoid_seleccion.colegio = this.eventoid_seleccion.colegio_datos.nombre;
            this.eventoid_seleccion.rbd_colegio = this.eventoid_seleccion.colegio_datos.rbd;
        },
        normalizarCursoMulti(cursoMulti) {
            if (Array.isArray(cursoMulti)) {
                return cursoMulti
                    .map((curso) => (curso || '').toString().trim())
                    .filter((curso) => curso !== '');
            }

            if (typeof cursoMulti === 'string') {
                const cursoLimpio = cursoMulti.endsWith(';')
                    ? cursoMulti.slice(0, -1)
                    : cursoMulti;

                return cursoLimpio
                    .split(';')
                    .map((curso) => curso.trim())
                    .filter((curso) => curso !== '');
            }

            return [];
        },
        select1(){
            // Mantener los datos completos devueltos por la API y no pisarlos con el objeto del buscador.
            if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                this.eventoid_seleccion1 = this.eventoid_seleccion || {};
            }
            const tipoCodigo = this.eventoid_seleccion1.tipo_codigo || this.eventoid_seleccion1.tipo;
            const subtipoCodigo = this.eventoid_seleccion1.subtipo_codigo || this.eventoid_seleccion1.subtipo;
            const tipoEncontrado = this.tipos.find((us) => us.codigo == tipoCodigo);
            const subtipoEncontrado = this.subtipos.find((us) => us.codigo == subtipoCodigo);
            this.eventoid_seleccion1.tipo_nombre = tipoEncontrado ? tipoEncontrado.nombre : (this.eventoid_seleccion1.tipo_nombre || '');
            this.eventoid_seleccion1.subtipo_nombre = subtipoEncontrado ? subtipoEncontrado.nombre : (this.eventoid_seleccion1.subtipo_nombre || '');
            if (this.eventoid_seleccion1.curso_multi && this.eventoid_seleccion1.curso_multi!='') {
                const cursosRaw = this.eventoid_seleccion1.curso_multi;
                this.eventoid_seleccion1.cursos = cursosRaw;
                this.eventoid_seleccion1.curso_multi = this.normalizarCursoMulti(cursosRaw);
            }
            this.eventoid_seleccion.estado_actividad= this.estados_eventos.filter((us) => us.nombre==this.eventoid_seleccion.estado_actividad);
        },
        select(){
            this.eventoid_seleccion.colegio_datos= this.colegios.find((us) => us.rbd==this.eventoid_seleccion.rbd_colegio);
            const tipoActual = this.eventoid_seleccion.tipo;
            const tipoPorCodigo = this.tipos.find((us) => us.codigo == tipoActual);
            const tipoPorId = this.tipos.find((us) => us.id == tipoActual);
            this.eventoid_seleccion.tipo = tipoPorCodigo || tipoPorId || tipoActual;
            this.ver_subtipo();

            const subtipoActual = this.eventoid_seleccion.subtipo;
            const subtipoPorCodigo = this.subtipos.find((us) => us.codigo == subtipoActual);
            const subtipoPorId = this.subtipos.find((us) => us.id == subtipoActual);
            this.eventoid_seleccion.subtipo = subtipoPorCodigo || subtipoPorId || subtipoActual;
            const coordinadorActual = this.eventoid_seleccion.coordinador_evento;
            const propietarioActual = this.eventoid_seleccion.propietario;
            this.eventoid_seleccion.coordinador_evento= this.usuarios.find((us) => us.name==coordinadorActual) || coordinadorActual || null;
            this.eventoid_seleccion.propietario= this.usuarios.find((us) => us.name==propietarioActual) || propietarioActual || null;
        },
        consultarEvento() {
            const id = this.eventoseleccionada.codigo; // Id del evento seleccionado
            this.eventoid_seleccion = this.eventoseleccionada
            this.isLoading=true
            axios.get(`/api/get_evento_crm/${id}`)
                .then(response => {
                    if(response.data.estado){
                        this.eventoid_seleccion=response.data.evento
                        this.eventoid_seleccion1=response.data.evento
                        this.select1()
                        this.select()
                        this.eventoid_seleccion.curso_multi = this.normalizarCursoMulti(this.eventoid_seleccion.curso_multi);

                        Swal.fire({
                            icon: "success",
                            title: "Buscando evento..",
                            text: "La información del evento se ha actualizado correctamente.",
                            timer: 3000,
                            showConfirmButton: false
                        });

                        if (this.eventoid_seleccion1 && this.eventoid_seleccion1.id) {
                            this.cargarPagosLaborantesEvento(this.eventoid_seleccion1.id);
                            this.cargarGastosEvento(this.eventoid_seleccion1.id);
                            this.cargarAsistentesEvento(this.eventoid_seleccion1.id);
                            this.cargarDigitalizadosEvento(this.eventoid_seleccion1.id);
                            this.cargarComentariosEvento(this.eventoid_seleccion1.id);
                        } else {
                            this.pagosLaborantesEvento = [];
                            this.digitalizadosEvento = [];
                            this.comentariosEvento = [];
                            this.comentarioEventoNuevo = '';
                            if (this.eventoid_seleccion1 && typeof this.eventoid_seleccion1 === 'object') {
                                this.$set(this.eventoid_seleccion1, 'gastos', []);
                                this.$set(this.eventoid_seleccion1, 'asistentes', []);
                                this.$set(this.eventoid_seleccion1, 'digitalizados', []);
                            }
                        }
                    }else{
                        const eventoLocal = response && response.data ? response.data.evento : null;

                        if (eventoLocal && typeof eventoLocal === 'object') {
                            this.eventoid_seleccion = eventoLocal;
                            this.eventoid_seleccion1 = eventoLocal;
                            this.select1();
                            this.select();
                            this.eventoid_seleccion.curso_multi = this.normalizarCursoMulti(this.eventoid_seleccion.curso_multi);

                            Swal.fire({
                                icon: "warning",
                                title: "CRM no disponible",
                                text: "Se muestran datos locales del evento.",
                                timer: 3000,
                                showConfirmButton: false
                            });

                            this.EventoNoExiste = false;

                            if (this.eventoid_seleccion1 && this.eventoid_seleccion1.id) {
                                this.cargarPagosLaborantesEvento(this.eventoid_seleccion1.id);
                                this.cargarGastosEvento(this.eventoid_seleccion1.id);
                                this.cargarAsistentesEvento(this.eventoid_seleccion1.id);
                                this.cargarDigitalizadosEvento(this.eventoid_seleccion1.id);
                                this.cargarComentariosEvento(this.eventoid_seleccion1.id);
                            }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Sin datos del evento..",
                                text: "Evento no existe en CRM..",
                                timer: 3000,
                                showConfirmButton: false
                            });
                            console.log("No existen datos del evento en crm: "+id);
                            console.log(response.data.evento);
                            this.EventoNoExiste=true;
                            this.pagosLaborantesEvento = [];
                            this.digitalizadosEvento = [];
                            this.comentariosEvento = [];
                            this.comentarioEventoNuevo = '';
                        }
                    }
                })
                .catch(error => {
                    console.error('Error al consultar evento', error);
                    Swal.fire({
                        icon: "error",
                        title: "Error al consultar",
                        text: "No fue posible cargar el evento. Intenta nuevamente.",
                        timer: 3000,
                        showConfirmButton: false
                    });
                    this.pagosLaborantesEvento = [];
                    this.digitalizadosEvento = [];
                    this.comentariosEvento = [];
                    this.comentarioEventoNuevo = '';
                })
                .finally(() => {
                    this.isLoading=false
                });
        },
        cargarPagosLaborantesEvento(eventoId) {
            axios.get(`/api/pagos_evento/${eventoId}`).then(res => {
                this.pagosLaborantesEvento = (res.data && res.data.pagos_laborantes) ? res.data.pagos_laborantes : [];
            }).catch(err => {
                console.error('Error al cargar pagos del evento', err);
                this.pagosLaborantesEvento = [];
            });
        },
        cargarGastosEvento(eventoId) {
            axios.get(`/api/get_gastos_evento/${eventoId}`).then(res => {
                const gastos = (res.data && Array.isArray(res.data.gastos)) ? res.data.gastos : [];
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'gastos', gastos);
            }).catch(err => {
                console.error('Error al cargar gastos del evento', err);
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'gastos', []);
            });
        },
        cargarAsistentesEvento(eventoId) {
            axios.get(`/api/get_asistentes_evento/${eventoId}`).then(res => {
                const asistentes = (res.data && Array.isArray(res.data.asistentes)) ? res.data.asistentes : [];
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'asistentes', asistentes);
            }).catch(err => {
                console.error('Error al cargar asistentes del evento', err);
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'asistentes', []);
            });
        },
        cargarDigitalizadosEvento(eventoId) {
            axios.get('/api/get_asociados', {
                params: {
                    evento_id: eventoId,
                }
            }).then(res => {
                const digitalizados = (res.data && Array.isArray(res.data.asociados)) ? res.data.asociados : [];
                this.digitalizadosEvento = digitalizados;
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'digitalizados', digitalizados);
            }).catch(err => {
                console.error('Error al cargar digitalizados del evento', err);
                this.digitalizadosEvento = [];
                if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                    this.eventoid_seleccion1 = {};
                }
                this.$set(this.eventoid_seleccion1, 'digitalizados', []);
            });
        },
        cargarComentariosEvento(eventoId) {
            axios.get(`/api/get_comentarios_evento/${eventoId}`).then(res => {
                this.comentariosEvento = (res.data && Array.isArray(res.data.comentarios)) ? res.data.comentarios : [];
            }).catch(err => {
                console.error('Error al cargar comentarios del evento', err);
                this.comentariosEvento = [];
            });
        },
        formatFechaHora(fecha) {
            if (!fecha) return '-';
            const opciones = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
            return new Date(fecha).toLocaleString('es-ES', opciones);
        },
        guardarComentarioEvento() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                this.msg('warning', 'Debes seleccionar un evento');
                return;
            }

            const comentario = (this.comentarioEventoNuevo || '').trim();
            if (!comentario) {
                this.msg('warning', 'El comentario no puede estar vacío');
                return;
            }

            if (comentario.length > 2000) {
                this.msg('warning', 'El comentario no puede superar 2000 caracteres');
                return;
            }

            this.guardandoComentarioEvento = true;
            axios.post('/api/guardar_comentario_evento', {
                evento_id: this.eventoid_seleccion1.id,
                comentario,
            }).then((response) => {
                if (response.data && response.data.estado) {
                    this.comentariosEvento = response.data.comentarios || [];
                    this.comentarioEventoNuevo = '';
                    this.msg('success', response.data.mensaje || 'Comentario guardado');
                    return;
                }

                this.msg('error', (response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudo guardar el comentario');
            }).catch((error) => {
                const mensaje = error?.response?.data?.mensaje || 'No se pudo guardar el comentario';
                this.msg('error', mensaje);
            }).finally(() => {
                this.guardandoComentarioEvento = false;
            });
        },
        marcarReenvioAsistente(asistente, marcado) {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id || !asistente || !asistente.id) {
                return;
            }

            this.isLoading = true;
            axios.post('/api/marcar_asistentes_reenvio', {
                id: this.eventoid_seleccion1.id,
                asistentes: [asistente.id],
                marcado,
            }).then((res) => {
                Swal.fire({
                    icon: res.data && res.data.estado ? 'success' : 'warning',
                    title: (res.data && res.data.mensaje) ? res.data.mensaje : 'Estado de reenvío actualizado',
                    timer: 2800,
                    showConfirmButton: false,
                });
                this.cargarAsistentesEvento(this.eventoid_seleccion1.id);
            }).catch((err) => {
                const mensaje = (err && err.response && err.response.data && err.response.data.mensaje)
                    ? err.response.data.mensaje
                    : 'No se pudo actualizar la marca de reenvío';
                Swal.fire({
                    icon: 'error',
                    title: mensaje,
                    timer: 3200,
                    showConfirmButton: false,
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        marcarAsistentesPorEstado(estados, etiqueta) {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id || !Array.isArray(this.eventoid_seleccion1.asistentes)) {
                return;
            }

            const asistentesIds = this.eventoid_seleccion1.asistentes
                .filter((asistente) => {
                    const estado = asistente && asistente.estado_crm ? asistente.estado_crm : 'pendiente_envio';
                    return estados.includes(estado) && !asistente.marcado_reenvio_crm;
                })
                .map((asistente) => asistente.id)
                .filter((id) => !!id);

            if (!asistentesIds.length) {
                Swal.fire({
                    icon: 'info',
                    title: `No hay asistentes ${etiqueta} disponibles para marcar`,
                    timer: 2500,
                    showConfirmButton: false,
                });
                return;
            }

            this.isLoading = true;
            axios.post('/api/marcar_asistentes_reenvio', {
                id: this.eventoid_seleccion1.id,
                asistentes: asistentesIds,
                marcado: true,
            }).then((res) => {
                Swal.fire({
                    icon: res.data && res.data.estado ? 'success' : 'warning',
                    title: (res.data && res.data.mensaje) ? res.data.mensaje : 'Asistentes marcados para reenvío',
                    text: `Marcados: ${Number((res.data && res.data.actualizados) || asistentesIds.length)}`,
                    timer: 3200,
                    showConfirmButton: false,
                });
                this.cargarAsistentesEvento(this.eventoid_seleccion1.id);
            }).catch((err) => {
                const mensaje = (err && err.response && err.response.data && err.response.data.mensaje)
                    ? err.response.data.mensaje
                    : 'No se pudo marcar el grupo de asistentes';
                Swal.fire({
                    icon: 'error',
                    title: mensaje,
                    timer: 3200,
                    showConfirmButton: false,
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        reenviarAsistentesMarcados() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                Swal.fire('Evento no seleccionado');
                return;
            }

            if (!this.asistentesMarcadosReenvio) {
                Swal.fire({
                    icon: 'info',
                    title: 'No hay asistentes marcados para reenvío',
                    timer: 2500,
                    showConfirmButton: false,
                });
                return;
            }

            this.loadingTitle = 'Programando reenvío...';
            this.loadingSubtitle = 'Se está enviando el lote a segundo plano. Esto debería tardar solo unos segundos.';
            this.isLoading = true;
            axios.post('/api/reenviar_asistentes_crm', {
                id: this.eventoid_seleccion1.id,
                limit: 50,
                solo_marcados: true,
            }).then((res) => {
                const despachados = Number((res.data && res.data.despachados) || 0);
                const errores = Number((res.data && res.data.errores) || 0);
                Swal.fire({
                    icon: res.data && res.data.estado ? 'success' : 'warning',
                    title: (res.data && res.data.mensaje) ? res.data.mensaje : 'Reenvío programado',
                    text: `Programados: ${despachados} | Errores al programar: ${errores}`,
                    timer: 4200,
                    showConfirmButton: false,
                });
                this.cargarAsistentesEvento(this.eventoid_seleccion1.id);
            }).catch((err) => {
                const mensaje = (err && err.response && err.response.data && err.response.data.mensaje)
                    ? err.response.data.mensaje
                    : 'No se pudo programar el reenvío';
                Swal.fire({
                    icon: 'error',
                    title: mensaje,
                    timer: 3500,
                    showConfirmButton: false,
                });
            }).finally(() => {
                this.isLoading = false;
                this.loadingTitle = 'Cargando...';
                this.loadingSubtitle = 'Esto podría tardar unos segundos.';
            });
        },
        formatCLP(valor) {
            const numero = parseInt((valor || 0).toString().replace(/[^0-9]/g, ''), 10) || 0;
            return numero.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' });
        },
        ver_subtipo(){
            const tipoSeleccionado = this.eventoid_seleccion && this.eventoid_seleccion.tipo;
            const tipoId = tipoSeleccionado && typeof tipoSeleccionado === 'object'
                ? tipoSeleccionado.id
                : null;

            this.subtiposfilter = tipoId
                ? this.subtipos.filter((subtipo) => subtipo.tipo_id == tipoId)
                : [];
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        ver_colegio(rbd){
            if (!rbd) {
                return;
            }
            localStorage.setItem('rbd_colegio',rbd);
            window.location.href = "/web/configuracion/colegios";
        },
        buscar_colegio(){
            localStorage.setItem("rbd_colegio", this.eventoid_seleccion.rbd_colegio);
            window.location.href = "/web/configuracion/colegios";
        },
        msgval(campo) {
            Swal.fire({
                icon: 'error',
                title: 'Campo Obligatorio',
                text: `Por favor, completa el campo "${campo}".`,
                confirmButtonText: 'Aceptar'
            });
        },
        validacion() {
            const campos = {
                nombre_difusion: 'Actividad',
                codigo: 'Código',
                fecha_inicio: 'Fecha Inicio',
                fecha_termino: 'Fecha Término',
                tipo: 'Tipo',
                subtipo: 'Subtipo',
                curso_multi: 'Curso',
                correo_notificaciones: 'Correo notificaciones',
                telefono_notificaciones: 'Teléfono notificaciones',
                nombre_difusion: 'Nombre para Difusión Digital',
                coordinador_evento: 'Coordinador evento',
            };
            for (let campo in campos) {
                if (!this.eventoid_seleccion[campo]) {
                    this.msgval(campos[campo]);
                    return false;
                }
            }
            return true;//this.crear_evento();
        },
        async copiarLink(link) {
            try {
                await navigator.clipboard.writeText(link);
                this.copiado = true;
                this.$toasted.success('Link Copiado');
                setTimeout(() => (this.copiado = false), 2000);
            } catch (err) {
                this.$toasted.error("Error al copiar: ", err);
            }
        },
        linkCredencialDigital(evento) {
            if (!evento || !evento.codigo) return '';
            return `${window.location.origin}/credencialdigital/${encodeURIComponent(evento.codigo)}`;
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        labelselect_usuarios ({ name }) {
            return `${name}`
        },
        labelselect_colegio ({ nombre , rbd}) {
            return `${rbd}-${nombre}`
        },
        valorLegible(input) {
            if (input === null || input === undefined) {
                return '';
            }

            if (typeof input === 'object') {
                return input.name
                    || input.nombre
                    || input.propietario
                    || input.coordinador_evento
                    || input.rut
                    || '';
            }

            if (typeof input !== 'string') {
                return String(input);
            }

            const valor = input.trim();
            if (!valor) {
                return '';
            }

            if ((valor.startsWith('{') && valor.endsWith('}')) || (valor.startsWith('[') && valor.endsWith(']'))) {
                try {
                    const json = JSON.parse(valor);

                    if (Array.isArray(json)) {
                        return json
                            .map((item) => this.valorLegible(item))
                            .filter((item) => !!item)
                            .join(', ');
                    }

                    return this.valorLegible(json);
                } catch (e) {
                    return valor;
                }
            }

            return valor;
        },
        estadoActividadLegible(input) {
            if (input === null || input === undefined) {
                return '';
            }

            if (Array.isArray(input)) {
                if (!input.length) return '';
                return this.estadoActividadLegible(input[0]);
            }

            if (typeof input === 'object') {
                return input.nombre || input.codigo || input.estado || '';
            }

            if (typeof input === 'string') {
                const valor = input.trim();
                if (!valor) return '';

                if ((valor.startsWith('{') && valor.endsWith('}')) || (valor.startsWith('[') && valor.endsWith(']'))) {
                    try {
                        return this.estadoActividadLegible(JSON.parse(valor));
                    } catch (e) {
                        return valor;
                    }
                }

                return valor;
            }

            return String(input);
        },
        eliminar(id){
            Swal.fire({
                title: '¿Estas seguro que deseas eliminar el evento?',
                text: "Esto no se podrá revertir",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#40afd8',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, estoy seguro',
                cancelButtonText: 'Cancelar',
                }).then((result) => {
                if (result.isConfirmed) {
                    let formData = new FormData();
                    formData.append('id', id);
                    axios.post('/api/eliminar_evento',formData).then(res=>{
                        if (res.data.estado) {
                            Swal.fire({
                                title: 'Eliminado',
                                text: "Evento eliminado",
                                icon: 'success',
                                confirmButtonColor: '#40afd8',
                                confirmButtonText: 'Aceptar',
                            })
                        }else{
                            Swal.fire({
                                title: 'No se puede eliminar',
                                text: res.data.mensaje,
                                icon: 'warning',
                                confirmButtonColor: '#40afd8',
                                confirmButtonText: 'Aceptar',
                            })
                        }

                    });
                }
            });
        },
        cambio_estado(es){
            let formData = new FormData();
            formData.append('id', this.eventoid_seleccion1.id);
            formData.append('estado', es);
            axios.post('/api/cambio_estado',formData).then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        icon: "success",
                        title: "Cambio de estado exitoso",
                        text: es,
                        timer: 5000,
                        showConfirmButton: false
                    });
                    this.eventoseleccionada = this.eventos.filter(us=>us.codigo==this.eventoid_seleccion1.codigo);
                    this.consultarEvento();
                }else{
                    Swal.fire({
                        icon: "error",
                        title: "No se cambió el estado",
                        text: '',
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            });
        },
        correo_agradecimiento(){
            axios.get('/api/envio_agradecimiento').then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        icon: "success",
                        title: "Envio de correo exitoso",
                        text: '',
                        timer: 5000,
                        showConfirmButton: false
                    });
                }
            });
        },
        toggleUploadAsistentes() {
            this.showUploadAsistentes = !this.showUploadAsistentes;
            if (!this.showUploadAsistentes) this.resetAsistentesFileInput();
        },
        resetAsistentesFileInput() {
            this.selectedAsistentesFile = null;
            if (this.$refs.asistentesFileInput && this.$refs.asistentesFileInput.reset) {
                this.$refs.asistentesFileInput.reset();
            }
            this.asistentesFileKey += 1;
        },
        async validarEstructuraArchivoAsistentes(file) {
            const requiredHeaders = ['rut', 'nombres', 'apellido_paterno', 'apellido_materno', 'rbd', 'celular', 'email', 'curso'];
            const buffer = await file.arrayBuffer();
            const workbook = XLSX.read(buffer, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];

            if (!firstSheetName) {
                throw new Error('El archivo no contiene hojas para importar.');
            }

            const sheet = workbook.Sheets[firstSheetName];
            const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false, defval: '' });

            if (!rows.length) {
                throw new Error('El archivo esta vacio.');
            }

            const headers = (rows[0] || [])
                .map((value) => String(value || '').trim().toLowerCase());

            const faltantes = requiredHeaders.filter((header) => !headers.includes(header));
            if (faltantes.length) {
                throw new Error(`Faltan columnas obligatorias: ${faltantes.join(', ')}.`);
            }

            if (rows.length < 2) {
                throw new Error('El archivo no contiene filas de asistentes para cargar.');
            }
        },
        onFileChange(event) {
            const file = event.target.files && event.target.files[0];

            if (!file) {
                this.selectedAsistentesFile = null;
                return;
            }

            const nombre = String(file.name || '').toLowerCase();
            const esArchivoValido = nombre.endsWith('.xlsx') || nombre.endsWith('.xls') || nombre.endsWith('.csv');

            if (!esArchivoValido) {
                this.resetAsistentesFileInput();
                Swal.fire({
                    icon: 'warning',
                    title: 'Formato no valido',
                    text: 'Debe seleccionar un archivo .xlsx, .xls o .csv para cargar asistentes.',
                    timer: 3500,
                    showConfirmButton: false,
                });
                return;
            }

            this.selectedAsistentesFile = file;
        },
        async descargarPlantillaAsistentes() {
            return this.runDownload('plantilla_asistentes', async () => {
                const filas = [
                    ['rut', 'nombres', 'apellido_paterno', 'apellido_materno', 'RBD', 'celular', 'email', 'curso'],
                    ['12345678-9', 'Nombre', 'ApellidoPaterno', 'ApellidoMaterno', '1111', '+56912345678', 'correo@ejemplo.cl', '4']
                ];

                const worksheet = XLSX.utils.aoa_to_sheet(filas);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Asistentes');

                const excelBuffer = XLSX.write(workbook, { bookType: 'biff8', type: 'array' });
                const blob = new Blob([
                    excelBuffer
                ], {
                    type: 'application/vnd.ms-excel'
                });

                saveAs(blob, 'plantilla_asistentes.xls');
            }, {
                message: 'Se esta preparando la plantilla de asistentes en formato XLS. La descarga iniciara en unos segundos.'
            });
        },
        descargarAsistentesExcel() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) return;
            window.location.href = '/api/export_asistentes/' + this.eventoid_seleccion1.id;
        },
        uploadAsistentes() {
            if (!this.selectedAsistentesFile) {
                this.$toasted && this.$toasted.error ? this.$toasted.error('Seleccione un archivo') : Swal.fire('Seleccione un archivo');
                return;
            }
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                Swal.fire('Evento no seleccionado');
                return;
            }
            this.validarEstructuraArchivoAsistentes(this.selectedAsistentesFile)
                .then(() => {
                    const formData = new FormData();
                    formData.append('id', this.eventoid_seleccion1.id);
                    formData.append('file', this.selectedAsistentesFile);
                    this.isLoading = true;
                    return axios.post('/api/upload_asistentes', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                })
                .then(res => {
                    if (res.data && res.data.estado) {
                        if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                            this.eventoid_seleccion1 = {};
                        }
                        this.$set(this.eventoid_seleccion1, 'asistentes', res.data.asistentes || []);
                        const crmDespachados = Number(res.data.crm_despachados || 0);
                        const crmErrores = Number(res.data.crm_errores || 0);
                        const detalleCRM = `CRM enviados: ${crmDespachados} | CRM con error: ${crmErrores}`;
                        Swal.fire({
                            icon: 'success',
                            title: res.data.mensaje || 'Asistentes cargados',
                            text: detalleCRM,
                            timer: 4500,
                            showConfirmButton: false
                        });
                        this.showUploadAsistentes = false;
                        this.resetAsistentesFileInput();
                    } else {
                        Swal.fire({ icon: 'error', title: res.data.mensaje || 'Error al cargar asistentes', timer: 3000, showConfirmButton: false });
                    }
                })
                .catch(err => {
                    console.error(err);
                    const data = err && err.response && err.response.data ? err.response.data : null;
                    const mensaje = (data && data.mensaje)
                        ? data.mensaje
                        : (err && err.message)
                            ? err.message
                        : 'Error al subir archivo';

                    // Si el backend devuelve detalle de filas con errores, mostrarlo en HTML.
                    if (data && Array.isArray(data.errores_filas) && data.errores_filas.length) {
                        const cursosValidos = (data && Array.isArray(data.cursos_validos))
                            ? data.cursos_validos
                            : [];
                        const cursosValidosHtml = cursosValidos.length
                            ? `<div style="text-align:left;margin-bottom:10px;"><strong>Cursos válidos:</strong> ${cursosValidos.join(', ')}</div>`
                            : '';
                        const filasHtml = data.errores_filas.slice(0, 50).map(e => {
                            const motivos = (e.motivos || []).map(m => `<li>${m}</li>`).join('');
                            const rut = e.rut ? ` &mdash; RUT: <code>${e.rut}</code>` : '';
                            const nombre = e.nombre ? ` &mdash; ${e.nombre}` : '';
                            return `<div style="text-align:left;margin-bottom:8px;"><strong>Fila ${e.fila}</strong>${rut}${nombre}<ul style="margin:4px 0 0 18px;">${motivos}</ul></div>`;
                        }).join('');
                        const extra = data.errores_filas.length > 50
                            ? `<p style="text-align:left;font-style:italic;">...y ${data.errores_filas.length - 50} fila(s) más con errores.</p>`
                            : '';
                        Swal.fire({
                            icon: 'error',
                            title: mensaje,
                            html: `<div style="max-height:60vh;overflow:auto;font-size:13px;">${cursosValidosHtml}${filasHtml}${extra}</div>`,
                            width: '700px',
                            confirmButtonText: 'Entendido'
                        });
                    } else {
                        Swal.fire({ icon: 'error', title: mensaje, timer: 3500, showConfirmButton: false });
                    }
                })
                .finally(() => { this.isLoading = false });
        },
        confirmarEliminarAsistentes() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                Swal.fire('Evento no seleccionado');
                return;
            }

            Swal.fire({
                title: 'Eliminar asistentes',
                text: '¿Está seguro de eliminar todos los asistentes de este evento? Esta acción no se puede deshacer.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.eliminarAsistentesEvento();
                }
            });
        },
        eliminarAsistentesEvento() {
            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                return;
            }

            this.isLoading = true;
            axios.post('/api/eliminar_asistentes_evento', { id: this.eventoid_seleccion1.id })
                .then((res) => {
                    if (res.data && res.data.estado) {
                        if (!this.eventoid_seleccion1 || typeof this.eventoid_seleccion1 !== 'object') {
                            this.eventoid_seleccion1 = {};
                        }
                        this.$set(this.eventoid_seleccion1, 'asistentes', []);
                        this.showUploadAsistentes = false;
                        this.resetAsistentesFileInput();

                        Swal.fire({
                            icon: 'success',
                            title: 'Asistentes eliminados',
                            text: `${res.data.eliminados || 0} registro(s) eliminado(s).`,
                            timer: 3000,
                            showConfirmButton: false
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: res.data && res.data.mensaje ? res.data.mensaje : 'No se pudieron eliminar los asistentes',
                            timer: 3000,
                            showConfirmButton: false
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    const mensaje = (err && err.response && err.response.data && err.response.data.mensaje)
                        ? err.response.data.mensaje
                        : 'Error al eliminar asistentes';
                    Swal.fire({
                        icon: 'error',
                        title: mensaje,
                        timer: 3500,
                        showConfirmButton: false
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        toggleGastoForm() {
            if (this.guardandoGasto) {
                return;
            }

            this.showGastoForm = !this.showGastoForm;
            if (!this.showGastoForm) {
                this.resetGastoForm();
            }
        },
        resolveDefaultCajaChicaId() {
            const idsDisponibles = (this.cajasChicas || []).map((caja) => String(caja.id));
            if (!idsDisponibles.length) {
                return '';
            }

            const preferidasPorUsuario = {
                '16': '1',
                '4': '2',
            };

            const userId = String((this.user && this.user.id) || '');
            const preferida = preferidasPorUsuario[userId];

            if (preferida && idsDisponibles.includes(preferida)) {
                return preferida;
            }

            return idsDisponibles[0];
        },
        resetGastoForm() {
            this.gasto = {
                tipo: null,
                monto: '$0',
                imagen: null,
                caja_chica_id: this.resolveDefaultCajaChicaId(),
            };
            this.tipoArchivo = '';
            this.imagenminiatura = '';
            if (this.$refs.inputDocumentoGasto) {
                this.$refs.inputDocumentoGasto.value = '';
            }
        },
        format_Valor() {
            this.gasto.monto = this.format_Valor_variable(this.gasto.monto);
            this.valor_editar.monto = this.format_Valor_variable(this.valor_editar.monto);
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        obtenerArchivoDesdeEntrada(payload) {
            if (!payload) return null;
            if (payload.target && payload.target.files) {
                return payload.target.files[0] || null;
            }
            if (typeof payload.length === 'number' && payload.length > 0 && payload[0]) {
                return payload[0] || null;
            }
            if (Array.isArray(payload)) {
                return payload[0] || null;
            }
            return payload instanceof File ? payload : null;
        },
        actualizarPreviewDocumento(file) {
            this.imagenminiatura = '';
            this.tipoArchivo = '';
            if (!file) return;

            const nombre = (file.name || '').toLowerCase();
            const extension = nombre.includes('.') ? nombre.split('.').pop() : '';

            if (file.type === 'application/pdf' || extension === 'pdf') {
                this.tipoArchivo = 'pdf';
                this.imagenminiatura = URL.createObjectURL(file);
                return;
            }

            const extensionesImagen = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif'];
            if ((file.type && file.type.startsWith('image/')) || extensionesImagen.includes(extension)) {
                this.tipoArchivo = 'imagen';
                this.imagenminiatura = URL.createObjectURL(file);
            }
        },
        obtenerImagen(eventoOArchivo) {
            const file = this.obtenerArchivoDesdeEntrada(eventoOArchivo);
            this.gasto.imagen = file || null;
            this.actualizarPreviewDocumento(file);
        },
        obtenerImagenEditar(eventoOArchivo) {
            const file = this.obtenerArchivoDesdeEntrada(eventoOArchivo);
            this.valor_editar.imagen = file || null;
            this.actualizarPreviewDocumento(file);
        },
        abrirSelectorDocumentoGasto() {
            if (this.guardandoGasto) {
                return;
            }

            if (this.$refs.inputDocumentoGasto) {
                this.$refs.inputDocumentoGasto.click();
            }
        },
        abrirSelectorDocumentoEditar() {
            if (this.$refs.inputDocumentoEditarEvento) {
                this.$refs.inputDocumentoEditarEvento.click();
            }
        },
        limpiarDocumentoGasto() {
            if (this.guardandoGasto) {
                return;
            }

            this.gasto.imagen = null;
            this.tipoArchivo = '';
            this.imagenminiatura = '';
            if (this.$refs.inputDocumentoGasto) {
                this.$refs.inputDocumentoGasto.value = '';
            }
        },
        limpiarDocumentoEditar() {
            this.valor_editar.imagen = null;
            this.tipoArchivo = '';
            this.imagenminiatura = '';
            if (this.$refs.inputDocumentoEditarEvento) {
                this.$refs.inputDocumentoEditarEvento.value = '';
            }
        },
        validaciones() {
            if (this.guardandoGasto) {
                return;
            }

            if (!this.gasto.tipo) {
                this.msgval('Tipo de gasto');
                return;
            }
            const montoLimpio = String(this.gasto.monto || '').replace(/[^0-9]/g, '');
            if (!montoLimpio || Number(montoLimpio) <= 0) {
                this.msgval('Monto del Gasto');
                return;
            }
            if (!this.gasto.imagen) {
                this.msgval('Documento Asociado');
                return;
            }
            if (this.gasto.imagen && this.gasto.imagen.size > (2 * 1024 * 1024)) {
                this.msg('error', 'El comprobante no puede superar 2 MB');
                return;
            }
            this.guardar();
        },
        guardar(){
            if (this.guardandoGasto) {
                return;
            }

            if (!this.eventoid_seleccion1 || !this.eventoid_seleccion1.id) {
                this.msg('error','Evento no seleccionado');
                return;
            }

            this.guardandoGasto = true;
            this.loadingTitle = 'Cargando gasto...';
            this.loadingSubtitle = 'Se esta subiendo el comprobante. No cierres ni vuelvas a presionar Guardar.';
            this.isLoading = true;

            let formData = new FormData();
            const montoLimpio = String(this.gasto.monto || '').replace(/[^0-9]/g, '');
            formData.append('evento_id', this.eventoid_seleccion1.id);
            formData.append('fecha', this.eventoid_seleccion1.fecha_inicio || '');
            formData.append('tipo', this.gasto.tipo);
            formData.append('monto', montoLimpio);
            formData.append('imagen', this.gasto.imagen);
            formData.append('caja_chica_id', this.gasto.caja_chica_id || '');
            formData.append('coordinador_id', this.eventoid_seleccion1.user_id || '');
            axios.post('/api/agregar_gastos',formData).then(res=>{
                if(res.data.estado){
                    this.resetGastoForm();
                    this.cargarGastosEvento(this.eventoid_seleccion1.id);
                    this.msg('success','Gasto agregado correctamente');
                }else{
                    this.msg('error', res.data.mensaje || 'Gasto No agregado');
                }
            }).catch((error) => {
                const mensaje = this.obtenerMensajeErrorAxios(error, 'Error al guardar gasto');
                this.msg('error', mensaje);
            }).finally(() => {
                this.guardandoGasto = false;
                this.isLoading = false;
                this.loadingTitle = 'Cargando...';
                this.loadingSubtitle = 'Esto podría tardar unos segundos.';
            });
        },
        resetExpensePreview() {
            if (this.previewObjectUrl) {
                URL.revokeObjectURL(this.previewObjectUrl);
            }
            this.previewObjectUrl = '';
            this.direccion = '';
            this.direccionMiniaturaS3 = '';
            this.extension = '';
            this.miniaturaS3Extension = '';
            this.archivoDisponible = true;
            this.archivoMensaje = '';
        },
        getExpensePreviewType(url) {
            const cleanUrl = String(url || '').split('?')[0].split('#')[0];
            const extension = (cleanUrl.split('.').pop() || '').toLowerCase();

            return extension === 'pdf' ? 'pdf' : 'img';
        },
        isProtectedExpenseUrl(url) {
            return typeof url === 'string' && url.startsWith('/api/gasto_archivo/');
        },
        async resolveProtectedExpenseUrl(fileUrl) {
            try {
                const response = await axios.get(fileUrl, {
                    responseType: 'blob',
                    validateStatus: () => true,
                });

                if (response.status >= 200 && response.status < 300) {
                    this.previewObjectUrl = URL.createObjectURL(response.data);
                    return {
                        disponible: true,
                        url: this.previewObjectUrl,
                    };
                }

                let mensaje = 'No se pudo cargar el comprobante.';
                try {
                    const rawText = response.data instanceof Blob ? await response.data.text() : '';
                    const parsed = rawText ? JSON.parse(rawText) : null;
                    mensaje = parsed && parsed.mensaje ? parsed.mensaje : mensaje;
                } catch (error) {
                    mensaje = response.status === 403
                        ? 'No autorizado'
                        : mensaje;
                }

                return {
                    disponible: false,
                    mensaje,
                };
            } catch (error) {
                const mensaje = error && error.response && error.response.data && error.response.data.mensaje
                    ? error.response.data.mensaje
                    : 'No se pudo cargar el comprobante.';

                return {
                    disponible: false,
                    mensaje,
                };
            }
        },
        async prepareExpensePreview(item) {
            this.resetExpensePreview();

            if (!item) {
                this.archivoDisponible = false;
                this.archivoMensaje = 'El gasto no tiene comprobante asociado.';
                return;
            }

            const fileUrl = item.comprobante_local_disponible === false && item.imagen_url_respaldo
                ? item.imagen_url_respaldo
                : (item.imagen_url || item.imagen_url_respaldo || '');

            if (!fileUrl) {
                this.archivoDisponible = false;
                this.archivoMensaje = 'El comprobante no está disponible ni localmente ni en S3.';
                return;
            }

            this.extension = this.getExpensePreviewType(fileUrl);

            const s3Url = String(item.imagen_url_respaldo || '');
            if (this.user && Number(this.user.id) === 1 && s3Url && s3Url !== fileUrl) {
                this.direccionMiniaturaS3 = s3Url;
                this.miniaturaS3Extension = this.getExpensePreviewType(s3Url);
            }

            if (this.isProtectedExpenseUrl(fileUrl)) {
                const resultado = await this.resolveProtectedExpenseUrl(fileUrl);
                this.archivoDisponible = resultado.disponible;
                this.archivoMensaje = resultado.mensaje || '';
                this.direccion = resultado.url || '';
                return;
            }

            this.direccion = fileUrl;
        },
        async ver_comprobante(item){
            await this.prepareExpensePreview(item);
            this.$refs['modal-imagen'].show();
        },
        async modal_editar(gasto) {
            this.valor_editar = {
                ...gasto,
                tipo: gasto.tipo_gasto,
                monto: this.format_Valor_variable(gasto.monto),
                imagen: null,
                caja_chica_id: gasto.caja_chica_id ? String(gasto.caja_chica_id) : '',
            };
            await this.prepareExpensePreview(gasto);
            this.cambiar = false;
            this.$refs['modal-editar'].show();
        },
        btn_cambiar() {
            this.cambiar = !this.cambiar;
            if (!this.cambiar) {
                this.limpiarDocumentoEditar();
            }
        },
        editar() {
            if (!this.valor_editar || !this.valor_editar.id) return;

            if (this.cambiar && this.valor_editar.imagen && this.valor_editar.imagen.size > (2 * 1024 * 1024)) {
                this.msg('error', 'El comprobante no puede superar 2 MB', '');
                return;
            }

            const formData = new FormData();
            formData.append('id', this.valor_editar.id);
            formData.append('tipo', this.valor_editar.tipo || '');
            formData.append('monto', String(this.valor_editar.monto || '').replace(/[^0-9]/g, ''));
            formData.append('caja_chica_id', this.valor_editar.caja_chica_id || '');
            if (this.cambiar && this.valor_editar.imagen) {
                formData.append('imagen', this.valor_editar.imagen);
            }

            axios.post('/api/editar_gastos', formData).then(res => {
                if (res.data && res.data.estado) {
                    this.cargarGastosEvento(this.eventoid_seleccion1.id);
                    this.msg('success', 'Gasto actualizado', '');
                } else {
                    this.msg('error', 'No se pudo actualizar', '');
                }
            }).catch((error) => {
                const mensaje = this.obtenerMensajeErrorAxios(error, 'No se pudo actualizar');
                this.msg('error', mensaje, '');
            });
        },
        eliminar_gasto(gasto) {
            if (!gasto || !gasto.id) return;
            Swal.fire({
                title: '¿Eliminar gasto?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#40afd8',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (!result.isConfirmed) return;

                const formData = new FormData();
                formData.append('gasto_id', gasto.id);
                axios.post('/api/eliminar_gastos', formData).then(res => {
                    if (res.data && res.data.estado) {
                        this.cargarGastosEvento(this.eventoid_seleccion1.id);
                        this.msg('success', 'Gasto eliminado', '');
                    } else {
                        this.msg('error', 'No se pudo eliminar', '');
                    }
                }).catch(() => {
                    this.msg('error', 'No se pudo eliminar', '');
                });
            });
        },
        msg(tipo,titulo,frase){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                text: frase,
                showConfirmButton: false,
                timer: 5000
            });
        },
        obtenerMensajeErrorAxios(error, mensajePorDefecto = 'Ha ocurrido un error') {
            const data = error && error.response ? error.response.data : null;
            if (data && data.errors && typeof data.errors === 'object') {
                const primerCampo = Object.keys(data.errors)[0];
                if (primerCampo && Array.isArray(data.errors[primerCampo]) && data.errors[primerCampo].length) {
                    return data.errors[primerCampo][0];
                }
            }
            if (data && data.mensaje) return data.mensaje;
            if (data && data.message) return data.message;
            return mensajePorDefecto;
        },
    },
    mounted(){
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
        axios.get('/api/get_colegios').then(res=>{
            this.colegios=res.data.colegios;
            this.todos_colegios=res.data.colegios;
        });
        axios.get('/api/get_usuarios').then(res=>{
            this.usuarios=res.data.usuarios;
        });
        axios.get('/api/cajas_chicas').then((response) => {
            if (response.data && response.data.estado) {
                this.cajasChicas = response.data.cajas || [];
                if (!this.gasto.caja_chica_id) {
                    this.gasto.caja_chica_id = this.resolveDefaultCajaChicaId();
                }
            }
        });
    },
    created(){
        this.isLoading=true;
        axios.get('/api/get_eventos').then(res=>{
            this.estados_eventos = res.data.estados_eventos;
            this.datoseventos=res.data.eventos
            this.eventos=res.data.eventos
            if (localStorage.getItem("evento_codigo")) {
                const evento_codigo = localStorage.getItem("evento_codigo");
                localStorage.removeItem("evento_codigo");
                this.eventoseleccionada=this.eventos.find(ev=>ev.codigo==evento_codigo)
                this.consultarEvento();
            }
            this.isLoading=false;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" :title="loadingTitle" :subtitle="loadingSubtitle" />
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="offset-md-2 col-md-8">
                                <div class="row">
                                    <div class="col-md-10">
                                        <b-form-group label="Buscar Evento:">
                                            <multiselect
                                                v-model="eventoseleccionada"
                                                :options="eventos"
                                                :custom-label="labelEvento"
                                                placeholder="Evento"
                                                selectLabel="Seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Remover"
                                                track-by="codigo"
                                                :searchable="true"
                                                :filterable="true"
                                                @select="onSelectEvento"
                                                >

                                                <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                                </template>
                                                <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!-- <div class="col-md-2">
                                        <b-button variant="primary" block @click="consultarEvento">Buscar</b-button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" >
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12" >
                                <div class="card mt-3 shadow-sm border-light evento-detail-card">
                                    <div class="card-body evento-detail-body">
                                        <div class="row" v-if="eventoid_seleccion!=''">
                                            <div class="col-md-12">
                                                <div class="evento-detail-hero" v-if="editing">
                                                    <div class="evento-detail-hero__eyebrow">Ficha del Evento</div>
                                                    <div class="evento-detail-hero__main">
                                                        <div class="evento-detail-hero__accent"></div>
                                                        <div class="evento-detail-hero__content">
                                                            <h1 class="evento-detail-title">{{ editing ?  eventoid_seleccion.nombre_difusion : eventoid_seleccion.nombre_difusion }}</h1>
                                                            <div class="evento-detail-subtitle">{{ editing ?  eventoid_seleccion.colegio : eventoid_seleccion.colegio }}</div>
                                                            <div class="evento-detail-meta">
                                                                <span class="evento-detail-meta__item">
                                                                    <span class="evento-detail-meta__label">Evento</span>
                                                                    <span class="evento-detail-meta__value">{{ eventoid_seleccion1.codigo || '-' }}</span>
                                                                </span>
                                                                <span class="evento-detail-meta__item">
                                                                    <span class="evento-detail-meta__label">RBD</span>
                                                                    <span class="evento-detail-meta__value">{{ editing ?  eventoid_seleccion.rbd_colegio : eventoid_seleccion.rbd_colegio }}</span>
                                                                </span>
                                                                <span class="evento-detail-meta__item">
                                                                    <span class="evento-detail-meta__label">Tipo</span>
                                                                    <span class="evento-detail-meta__value">{{ eventoid_seleccion1.tipo_nombre || '-' }}</span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="evento-detail-hero evento-detail-hero--ugm" v-else>
                                                    <div class="evento-detail-hero-bar">
                                                        <div class="evento-detail-hero-bar__left">
                                                            <div class="evento-detail-hero-bar__title-row">
                                                                <i class="bx bx-calendar-event evento-detail-hero-bar__icon"></i>
                                                                <h1 class="evento-detail-hero-bar__title">{{ eventoid_seleccion1.nombre_difusion }}</h1>
                                                            </div>
                                                            <div class="evento-detail-hero-bar__meta">
                                                                <span class="evento-detail-chip">{{ eventoid_seleccion1.codigo || '-' }}</span>
                                                                <span>{{ eventoid_seleccion1.colegio || '-' }}</span>
                                                                <span>(RBD {{ eventoid_seleccion1.rbd_colegio || '-' }})</span>
                                                            </div>
                                                        </div>
                                                        <div class="evento-detail-hero-bar__actions">
                                                            <b-button class="evento-detail-action-btn evento-detail-action-btn--white" @click="buscar_colegio()">Volver Colegio</b-button>
                                                            <b-button class="evento-detail-action-btn evento-detail-action-btn--danger evento-detail-action-btn--icon evento-detail-action-btn--subtle" @click="eliminar(eventoid_seleccion1.id)" v-if="user.id=='6' || user.id=='1'"><i class="bx bx-trash"></i></b-button>
                                                            <b-button @click="toggleEdit" class="evento-detail-action-btn evento-detail-action-btn--white evento-detail-action-btn--subtle">
                                                                <i class="fas fa-edit"></i> Editar..
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="editing">
                                                    <div class="col-md-6">
                                                        <div class="form-group row" >
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Colegio:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="eventoid_seleccion.colegio_datos"
                                                                    :options="colegios"
                                                                    placeholder="Seleccionar colegio"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_colegio"
                                                                    @select="onSelectColegio">
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="text" id="pais" v-model="eventoid_seleccion.colegio" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Actividad:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="pais" v-model="eventoid_seleccion.nombre_difusion" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Código:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="name" v-model="eventoid_seleccion.codigo" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <!-- <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Área:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="name" v-model="eventoid_seleccion.area" class="form-control border-primary">
                                                            </div>
                                                        </div> -->
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Fecha inicio:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="datetime-local" id="direccion" v-model="eventoid_seleccion.fecha_inicio" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Fecha de término:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="datetime-local" id="ciudad" v-model="eventoid_seleccion.fecha_termino" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono">Tipo:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary">* Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <!-- <p>{{ eventoid_seleccion.tipo }}</p> -->
                                                                <multiselect v-model="eventoid_seleccion.tipo"
                                                                    :options="tipos.filter(t => t.codigo != null)"
                                                                    placeholder="Seleccionar tipo"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo"
                                                                    @select="ver_subtipo()">
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    v-model="eventoid_seleccion.tipo"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar tipo</option>
                                                                    <option v-for="tipo in tipos.filter(t => t.codigo != null)" :key="tipo.codigo" :value="tipo.codigo">
                                                                        {{ tipo.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono">Subtipo:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary">* Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <!-- <p>{{ eventoid_seleccion.subtipo }}</p> -->
                                                                <multiselect v-model="eventoid_seleccion.subtipo"
                                                                    :options="subtiposfilter"
                                                                    placeholder="Seleccionar subtipo"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo" >
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    v-model="eventoid_seleccion.subtipo"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar subtipo</option>
                                                                    <option v-for="subtipo in subtipos.filter(sub=>sub.tipo_codigo==eventoid_seleccion.tipo)" :key="subtipo.codigo" :value="subtipo.codigo">
                                                                        {{ subtipo.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Curso:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="eventoid_seleccion.curso_multi"
                                                                    :options="cursos"
                                                                    :close-on-select="false"
                                                                    placeholder="Seleccionar curso"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :multiple="true"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="text" id="telefono" v-model="eventoid_seleccion.curso" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Correo Notificaciones:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="eventoid_seleccion.correo_notificaciones" class="form-control border-primary" @blur="validateEmail">
                                                                <p v-if="emailError" class="error text-primary">{{ emailError }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Teléfono Notificaciones:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="eventoid_seleccion.telefono_notificaciones" class="form-control border-primary" @input="formatPhoneNumber" @blur="validatePhoneNumber" @keydown="restrictToNumbers" maxlength="12">
                                                                <p v-if="phoneerror" class="error text-primary">{{ phoneerror }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="estado"> Estado:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="estado" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect v-model="eventoid_seleccion.estado_actividad"
                                                                    :options="estados_eventos"
                                                                    placeholder="Seleccionar estado"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_tipo" >
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <select
                                                                    id="estado"
                                                                    v-model="eventoid_seleccion.estado_actividad"
                                                                    class="form-control border-primary"
                                                                >
                                                                    <option disabled value="">Seleccionar estado</option>
                                                                    <option v-for="estado in estados_eventos" :key="estado.id" :value="estado.codigo">
                                                                        {{ estado.nombre }}
                                                                    </option>
                                                                </select> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Nombre para Difusión Digital:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="eventoid_seleccion.nombre_difusion" class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="comentario_nombre_evento"> Comentario:</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="comentario_nombre_evento" v-model="eventoid_seleccion.comentario_nombre_evento" class="form-control border-primary" maxlength="255">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Coordinador evento:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="eventoid_seleccion.coordinador_evento"
                                                                    :options="usuarios"
                                                                    placeholder="Seleccionar usuario"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="labelselect_usuarios"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                                <!-- <input type="email" id="email" v-model="eventoid_seleccion.coordinador_evento" class="form-control border-primary"> -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="email"> Propietario:</label>
                                                            <multiselect
                                                                v-model="eventoid_seleccion.propietario"
                                                                :options="usuarios"
                                                                placeholder="Seleccionar usuario"
                                                                selectLabel="Presiona para seleccionar"
                                                                selectedLabel="Seleccionado"
                                                                deselectLabel="Presiona para remover"
                                                                :custom-label="labelselect_usuarios"
                                                                >
                                                                <template v-slot:noOptions>
                                                                    <p>No hay opciones</p>
                                                                </template>
                                                                <template v-slot:noResult>
                                                                    <p>No se encuentra coincidencia</p>
                                                                </template>
                                                            </multiselect>
                                                            <!-- <input type="email" id="email" v-model="eventoid_seleccion.propietario" class="form-control border-primary"> -->
                                                        </div>
                                                    </div>
                                                    <div class="offset-md-9 col-md-3 mb-3">
                                                        <div class="mt-3 float-right">
                                                            <button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </button>
                                                            <button @click="toggleEdit" class="btn btn-primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar.' }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row evento-detail-readonly" v-else>
                                                    <div class="col-12" v-if="user && Number(user.id) === 1">
                                                        <div class="evento-detail-toolbar evento-detail-toolbar--secondary">
                                                            <div class="evento-detail-toolbar__left">
                                                                <b-button
                                                                    class="evento-detail-action-btn evento-detail-action-btn--gold"
                                                                    :disabled="isSendingPreview"
                                                                    @click="enviarPreviewCorreoEvento('creacion_evento')"
                                                                >
                                                                    <i class="bx bx-mail-send font-size-14"></i>
                                                                    {{ isSendingPreview ? 'Enviando preview...' : 'Preview correo' }}
                                                                </b-button>
                                                                <b-button
                                                                    class="evento-detail-action-btn evento-detail-action-btn--green"
                                                                    :disabled="isSendingEvaluacionPrueba"
                                                                    @click="enviarCorreoEvaluacionActividadPrueba"
                                                                >
                                                                    <i class="bx bx-envelope font-size-14"></i>
                                                                    {{ isSendingEvaluacionPrueba ? 'Enviando prueba...' : 'Enviar encuesta prueba' }}
                                                                </b-button>
                                                                <b-button
                                                                    class="evento-detail-action-btn evento-detail-action-btn--blue"
                                                                    :disabled="isOpeningEncuesta"
                                                                    @click="abrirLinkEncuestaActividad"
                                                                >
                                                                    <i class="bx bx-link-external font-size-14"></i>
                                                                    {{ isOpeningEncuesta ? 'Abriendo link...' : 'Ver encuesta' }}
                                                                </b-button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="offset-md-6 col-md-6 mb-2">
                                                        <div class="mt-3 float-right">
                                                            <label for="">Estado:</label>
                                                            <multiselect
                                                                v-model="estado"
                                                                :options="estados"
                                                                placeholder="Selecciona estado"
                                                                selectLabel="Presiona para seleccionar"
                                                                selectedLabel="Seleccionado"
                                                                deselectLabel="Presiona para remover"
                                                                @select="cambio_estado"
                                                                :close-on-select="true"
                                                                >
                                                                <template v-slot:noOptions>
                                                                    <p>No hay opciones</p>
                                                                </template>
                                                                <template v-slot:noResult>
                                                                    <p>No se encuentra coincidencia</p>
                                                                </template>
                                                            </multiselect>
                                                        </div>
                                                    </div> -->
                                                    <div class="col-md-6 evento-detail-column">
                                                        <div class="evento-detail-panel evento-detail-panel--ugm">
                                                            <div class="evento-detail-panel__title">Datos del Evento</div>
                                                            <div class="evento-detail-table">
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Actividad</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.nombre_difusion }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Código</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.codigo }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Fecha Inicio</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.fecha_inicio }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Fecha de término</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.fecha_termino }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Tipo</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.tipo_nombre }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Subtipo</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.subtipo_nombre }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Curso</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.cursos }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Correo Notificaciones</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.correo_notificaciones }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Teléfono Notificaciones</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.telefono_notificaciones }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row evento-detail-table__row--link" @click="ver_colegio(eventoid_seleccion1.rbd_colegio)" style="cursor: pointer;">
                                                                    <div class="evento-detail-table__label">RBD</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.rbd_colegio }} <i class="bx bx-link ml-1"></i></div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Colegio</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.colegio }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row evento-detail-table__row--wrap">
                                                                    <div class="evento-detail-table__label">Credencial digital</div>
                                                                    <div class="evento-detail-table__value evento-detail-table__value--link">
                                                                        <span>{{ linkCredencialDigital(eventoid_seleccion1) }}</span>
                                                                        <b-button size="sm" @click.stop="copiarLink(linkCredencialDigital(eventoid_seleccion1))"><i class="bx bx-copy-alt"></i></b-button>
                                                                    </div>
                                                                </div>
                                                                <div class="evento-detail-table__row evento-detail-table__row--wrap">
                                                                    <div class="evento-detail-table__label">Landing Asistencia</div>
                                                                    <div class="evento-detail-table__value evento-detail-table__value--link">
                                                                        <span>{{ eventoid_seleccion1.landing_asistencia }}</span>
                                                                        <b-button size="sm" @click.stop="copiarLink(eventoid_seleccion1.landing_asistencia)" v-if="eventoid_seleccion1.landing_asistencia!=null"><i class="bx bx-copy-alt"></i></b-button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 evento-detail-column">
                                                        <div class="evento-detail-panel evento-detail-panel--ugm">
                                                            <div class="evento-detail-panel__title">Coordinación y Difusión</div>
                                                            <div class="evento-detail-table">
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Nombre para Difusión Digital</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.nombre_difusion }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Comentario</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.comentario_nombre_evento || '-' }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Sede Asociada</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.sede_asociada }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Cantidad Inscripciones</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.cantidad_inscripciones }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Nº Asistentes</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.num_asistentes }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Propietario</div>
                                                                    <div class="evento-detail-table__value">{{ valorLegible(eventoid_seleccion1.propietario) }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Estado de la actividad</div>
                                                                    <div class="evento-detail-table__value">{{ estadoActividadLegible(eventoid_seleccion1.estado_actividad) }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Tipo Landing</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.landing }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Propietario Colegio</div>
                                                                    <div class="evento-detail-table__value">{{ valorLegible(eventoid_seleccion1.propietario_colegio) }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Coordinador Evento</div>
                                                                    <div class="evento-detail-table__value">
                                                                        <div>{{ coordinadorEventoInfo.nombre }}</div>
                                                                        <div v-if="coordinadorEventoInfo.rut" class="evento-detail-table__subvalue">{{ coordinadorEventoInfo.rut }}</div>
                                                                    </div>
                                                                </div>
                                                                <div class="evento-detail-table__row">
                                                                    <div class="evento-detail-table__label">Fecha Creación</div>
                                                                    <div class="evento-detail-table__value">{{ eventoid_seleccion1.fecha_creacion }}</div>
                                                                </div>
                                                                <div class="evento-detail-table__row evento-detail-table__row--wrap">
                                                                    <div class="evento-detail-table__label">Landing Inscripción</div>
                                                                    <div class="evento-detail-table__value evento-detail-table__value--link">
                                                                        <span>{{ eventoid_seleccion1.landing_inscripcion }}</span>
                                                                        <b-button size="sm" @click.stop="copiarLink(eventoid_seleccion1.landing_inscripcion)" v-if="eventoid_seleccion1.landing_inscripcion!=null"><i class="bx bx-copy-alt"></i></b-button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="evento-detail-tabs-wrap">
                                                    <b-tabs content-class="mt-3" class="evento-detail-tabs">
                                                        <b-tab title="Laborantes" :active="esDiaInicioEvento" :disabled="!esDiaInicioEvento">
                                                            <laborantesEvento
                                                                :evento-codigo="eventoid_seleccion1 && eventoid_seleccion1.codigo ? eventoid_seleccion1.codigo : null"
                                                                :allow-redirect="false"
                                                            />
                                                            <!-- <div v-if="eventoid_seleccion1 && eventoid_seleccion1.laborantes && eventoid_seleccion1.laborantes.length">
                                                                <ul class="list-group">
                                                                    <li class="list-group-item" v-for="(l, idx) in eventoid_seleccion1.laborantes" :key="idx">
                                                                        {{ l.name || l.nombre || l }}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div v-else>
                                                                <p class="text-muted">No hay laborantes registrados para este evento.</p>
                                                            </div> -->
                                                        </b-tab>
                                                        <b-tab title="Pagos Laborantes" v-if="pagosLaborantesPagados.length">
                                                            <div class="table-responsive mb-0 mt-2">
                                                                <table class="table table-hover">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style="width: 5%;">Nº</th>
                                                                            <th style="width: 20%;">Nombre</th>
                                                                            <th style="width: 20%;">Rut</th>
                                                                            <th style="width: 20%;">Monto</th>
                                                                            <th style="width: 15%;">Estado</th>
                                                                            <th style="width: 20%;">Fecha Pago</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item, idx) in pagosLaborantesPagados" :key="item.id || idx">
                                                                            <td>{{ idx + 1 }}</td>
                                                                            <td>{{ item.name || '-' }}</td>
                                                                            <td>{{ item.rut || '-' }}</td>
                                                                            <td>{{ formatCLP(item.monto) }}</td>
                                                                            <td>{{ item.estado || '-' }}</td>
                                                                            <td>{{ item.fecha_pago || '-' }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </b-tab>
                                                        <b-tab title="Gastos">
                                                            <div class="row mb-3">
                                                                <div class="col-md-12 text-right">
                                                                    <b-button v-if="!showGastoForm" variant="primary" @click="toggleGastoForm" :disabled="guardandoGasto">Agregar gasto</b-button>
                                                                    <b-button v-else variant="secondary" @click="toggleGastoForm" :disabled="guardandoGasto">Cancelar</b-button>
                                                                </div>
                                                            </div>
                                                            <div class="row" v-if="showGastoForm">
                                                                <div class="offset-md-2 col-md-8">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <div class="form-group row">
                                                                                <div class="col-md-6">
                                                                                    <label for="pais"> Tipo de gasto:</label>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <multiselect
                                                                                        v-model="gasto.tipo"
                                                                                        :options="tipos_gastos"
                                                                                        placeholder="Seleccionar tipo"
                                                                                        selectLabel="Presiona para seleccionar"
                                                                                        selectedLabel="Seleccionado"
                                                                                        deselectLabel="Presiona para remover"
                                                                                        >
                                                                                        <template v-slot:noOptions>
                                                                                            <p>No hay opciones</p>
                                                                                        </template>
                                                                                        <template v-slot:noResult>
                                                                                            <p>No se encuentra coincidencia</p>
                                                                                        </template>
                                                                                    </multiselect>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <div class="form-group row">
                                                                                <div class="col-md-6">
                                                                                    <label for="pais"> Monto del Gasto:</label>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <b-form-input v-model="gasto.monto" class="border-primary" @keydown="restrictToNumbers" @input="format_Valor"></b-form-input>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <div class="form-group row">
                                                                                <div class="col-md-6">
                                                                                    <label for="caja-chica-evento"> Caja chica:</label>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <b-form-select id="caja-chica-evento" v-model="gasto.caja_chica_id" :options="cajasChicasOptions"></b-form-select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <div class="form-group row">
                                                                                <div class="col-md-6">
                                                                                    <label for="pais"> Documento Asociado:</label>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <input
                                                                                        ref="inputDocumentoGasto"
                                                                                        type="file"
                                                                                        class="d-none"
                                                                                        accept="image/*,application/pdf"
                                                                                        @change="obtenerImagen"
                                                                                    >
                                                                                    <div class="carga-documento-mejorada" @click="abrirSelectorDocumentoGasto">
                                                                                        <div>
                                                                                            <strong>{{ gasto.imagen ? gasto.imagen.name : 'Ningun archivo seleccionado' }}</strong>
                                                                                            <div class="text-muted small">Formatos permitidos: JPG, PNG y PDF. Tamano maximo: 2 MB.</div>
                                                                                        </div>
                                                                                        <div class="carga-documento-mejorada__acciones">
                                                                                            <b-button variant="outline-primary" @click.stop="abrirSelectorDocumentoGasto" :disabled="guardandoGasto">
                                                                                                {{ gasto.imagen ? 'Cambiar archivo' : 'Elegir archivo' }}
                                                                                            </b-button>
                                                                                            <b-button v-if="gasto.imagen" variant="outline-secondary" @click.stop="limpiarDocumentoGasto" :disabled="guardandoGasto">
                                                                                                Quitar
                                                                                            </b-button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-12 text-right">
                                                                            <b-button variant="primary" @click="validaciones" :disabled="guardandoGasto">
                                                                                {{ guardandoGasto ? 'Cargando...' : 'Guardar' }}
                                                                            </b-button>
                                                                        </div>
                                                                        <div class="offset-md-1 col-md-10 text-center">
                                                                            <!-- Mostrar imagen si el archivo es imagen -->
                                                                            <figure v-if="tipoArchivo === 'imagen'">
                                                                                <img :src="imagenminiatura" height="400" alt="Imagen del producto">
                                                                            </figure>
                                                                            <!-- Mostrar PDF si el archivo es PDF -->
                                                                            <div v-if="tipoArchivo === 'pdf'">
                                                                                <pdf :src="imagenminiatura"></pdf>
                                                                                <!----> <embed :src="imagenminiatura" type="application/pdf" width="100%" height="500px" /> -->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3" v-if="gastosEvento.length">
                                                                <div class="col-md-12">
                                                                    <h5 class="text-primary mb-3">Gastos registrados</h5>
                                                                    <div class="table-responsive mb-0 mt-2">
                                                                        <table class="table table-hover">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style="width: 5%;">Nº</th>
                                                                                    <th style="width: 8%;">Tipo Gasto</th>
                                                                                    <th style="width: 10%;">Caja chica</th>
                                                                                    <th style="width: 10%;">Monto</th>
                                                                                    <th style="width: 20%;">Comprobante</th>
                                                                                    <th style="width: 20%;">Acciones</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr v-for="(g, idx) in gastosEvento" :key="g.id || idx">
                                                                                    <td>{{ idx + 1 }}</td>
                                                                                    <td>{{ g.tipo_gasto }}</td>
                                                                                    <td>{{ g.caja_chica_nombre || '-' }}</td>
                                                                                    <td>{{ formatCLP(g.monto) }}</td>
                                                                                    <td>
                                                                                        <b-button v-if="g.comprobante_disponible" variant="primary" @click="ver_comprobante(g)" size="sm">Ver</b-button>
                                                                                        <span v-else class="badge badge-secondary" title="El archivo fue subido con el sistema anterior y ya no está disponible en el servidor">Sin archivo</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <b-button variant="primary" @click="modal_editar(g)">Editar</b-button>
                                                                                        <b-button variant="danger" @click="eliminar_gasto(g)"><i class="bx bx-trash"></i></b-button>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar" size="xl">
                                                                            <div v-if="!archivoDisponible" class="alert alert-warning mb-0">
                                                                                {{ archivoMensaje }}
                                                                            </div>
                                                                            <div v-else class="row align-items-start">
                                                                                <div :class="mostrarMiniaturaComprobanteS3 ? 'col-lg-9 col-md-8' : 'col-12'">
                                                                                    <div v-if="extension=='pdf'">
                                                                                        <pdf :src="direccion"></pdf>
                                                                                    </div>
                                                                                    <img :src="direccion" width="100%" v-else>
                                                                                </div>
                                                                                <div v-if="mostrarMiniaturaComprobanteS3" class="col-lg-3 col-md-4 mt-3 mt-md-0">
                                                                                    <div class="card border h-100">
                                                                                        <div class="card-body p-2">
                                                                                            <div class="d-flex justify-content-between align-items-center mb-2">
                                                                                                <small class="text-muted">Vista S3</small>
                                                                                                <a :href="direccionMiniaturaS3" target="_blank" rel="noopener noreferrer">Abrir</a>
                                                                                            </div>
                                                                                            <div v-if="miniaturaS3Extension === 'pdf'">
                                                                                                <iframe :src="direccionMiniaturaS3" title="Miniatura comprobante S3" style="width: 100%; height: 260px; border: 0;"></iframe>
                                                                                            </div>
                                                                                            <img v-else :src="direccionMiniaturaS3" alt="Miniatura comprobante S3" style="width: 100%; max-height: 260px; object-fit: contain;">
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </b-modal>
                                                                        <b-modal ref="modal-editar" title="Editar Gasto" ok-title="Guardar" cancel-title="Cancelar" @ok="editar">
                                                                            <div class="row mt-4">
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group row">
                                                                                        <div class="col-md-6">
                                                                                            <label for="pais"> Tipo de gasto:</label>
                                                                                        </div>
                                                                                        <div class="col-md-12">
                                                                                            <multiselect
                                                                                                v-model="valor_editar.tipo"
                                                                                                :options="tipos_gastos"
                                                                                                placeholder="Seleccionar tipo"
                                                                                                selectLabel="Presiona para seleccionar"
                                                                                                selectedLabel="Seleccionado"
                                                                                                deselectLabel="Presiona para remover"
                                                                                                >
                                                                                                <template v-slot:noOptions>
                                                                                                    <p>No hay opciones</p>
                                                                                                </template>
                                                                                                <template v-slot:noResult>
                                                                                                    <p>No se encuentra coincidencia</p>
                                                                                                </template>
                                                                                            </multiselect>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group row">
                                                                                        <div class="col-md-6">
                                                                                            <label for="pais"> Monto del Gasto:</label>
                                                                                        </div>
                                                                                        <div class="col-md-12">
                                                                                            <b-form-input v-model="valor_editar.monto" class="border-primary" @input="format_Valor"></b-form-input>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group row">
                                                                                        <div class="col-md-6">
                                                                                            <label for="caja-chica-editar-evento"> Caja chica:</label>
                                                                                        </div>
                                                                                        <div class="col-md-12">
                                                                                            <b-form-select id="caja-chica-editar-evento" v-model="valor_editar.caja_chica_id" :options="cajasChicasOptions"></b-form-select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-12">
                                                                                    <b-button :variant="cambiar?'secondary':'primary'" @click="btn_cambiar">{{ cambiar ? 'No Cambiar' : 'Cambiar Documento'}}</b-button>
                                                                                    <div v-if="!cambiar">
                                                                                        <div v-if="!archivoDisponible" class="alert alert-warning mt-3 mb-0">
                                                                                            {{ archivoMensaje }}
                                                                                        </div>
                                                                                        <pdf :src="direccion" v-else-if="extension=='pdf'"></pdf>
                                                                                        <img :src="direccion" width="100%" v-else>
                                                                                    </div>
                                                                                    <div class="row" v-else>
                                                                                        <div class="col-md-12">
                                                                                            <div class="form-group row">
                                                                                                <div class="col-md-6">
                                                                                                    <label for="pais"> Documento Asociado:</label>
                                                                                                </div>
                                                                                                <div class="col-md-12">
                                                                                                    <input
                                                                                                        ref="inputDocumentoEditarEvento"
                                                                                                        type="file"
                                                                                                        class="d-none"
                                                                                                        accept="image/*,application/pdf"
                                                                                                        @change="obtenerImagenEditar"
                                                                                                    >
                                                                                                    <div class="carga-documento-mejorada" @click="abrirSelectorDocumentoEditar">
                                                                                                        <div>
                                                                                                            <strong>{{ valor_editar.imagen ? valor_editar.imagen.name : 'Ningun archivo seleccionado' }}</strong>
                                                                                                            <div class="text-muted small">Formatos permitidos: JPG, PNG y PDF. Tamano maximo: 2 MB.</div>
                                                                                                        </div>
                                                                                                        <div class="carga-documento-mejorada__acciones">
                                                                                                            <b-button variant="outline-primary" @click.stop="abrirSelectorDocumentoEditar">
                                                                                                                {{ valor_editar.imagen ? 'Cambiar archivo' : 'Elegir archivo' }}
                                                                                                            </b-button>
                                                                                                            <b-button v-if="valor_editar.imagen" variant="outline-secondary" @click.stop="limpiarDocumentoEditar">
                                                                                                                Quitar
                                                                                                            </b-button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="offset-md-1 col-md-10 text-center">
                                                                                            <figure v-if="tipoArchivo === 'imagen'">
                                                                                                <img :src="imagenminiatura" height="auto" alt="Imagen del producto">
                                                                                            </figure>
                                                                                            <div v-if="tipoArchivo === 'pdf'">
                                                                                                <pdf :src="imagenminiatura"></pdf>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </b-modal>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else class="text-center text-muted">
                                                                <p>No hay gastos registrados para este evento.</p>
                                                            </div>
                                                        </b-tab>
                                                        <b-tab title="Asistentes XLS">
                                                            <div class="text-right mb-2">
                                                                <b-button
                                                                    size="sm"
                                                                    variant="outline-info"
                                                                    class="mr-2"
                                                                    v-if="false"
                                                                    @click="marcarAsistentesPorEstado(['pendiente_envio', 'pendiente_reenvio', 'reenvio_programado'], 'pendientes')"
                                                                    :disabled="!asistentesPendientesDisponibles"
                                                                >
                                                                    Marcar pendientes disponibles ({{ asistentesPendientesDisponibles }})
                                                                </b-button>
                                                                <b-button
                                                                    size="sm"
                                                                    variant="outline-danger"
                                                                    class="mr-2"
                                                                    v-if="false"
                                                                    @click="marcarAsistentesPorEstado(['error_envio'], 'con error')"
                                                                    :disabled="!asistentesConErrorDisponibles"
                                                                >
                                                                    Marcar con error ({{ asistentesConErrorDisponibles }})
                                                                </b-button>
                                                                <b-button
                                                                    size="sm"
                                                                    variant="warning"
                                                                    class="mr-2"
                                                                    v-if="false"
                                                                    @click="reenviarAsistentesMarcados"
                                                                    :disabled="!asistentesMarcadosReenvio"
                                                                >
                                                                    Reenviar marcados ({{ asistentesMarcadosReenvio }})
                                                                </b-button>
                                                                <b-button
                                                                    size="sm"
                                                                    variant="danger"
                                                                    class="mr-2"
                                                                    v-if="puedeGestionarAsistentes && eventoid_seleccion1 && eventoid_seleccion1.asistentes && eventoid_seleccion1.asistentes.length"
                                                                    @click="confirmarEliminarAsistentes"
                                                                >
                                                                    <i class="bx bx-trash mr-1"></i>Eliminar carga
                                                                </b-button>
                                                                <b-button size="sm" variant="primary" @click="descargarPlantillaAsistentes" :disabled="isDownloadLoading('plantilla_asistentes')">
                                                                    <b-spinner small class="mr-2" v-if="isDownloadLoading('plantilla_asistentes')"></b-spinner>
                                                                    {{ getDownloadLabel('plantilla_asistentes', 'Descargar plantilla', 'Preparando plantilla...') }}
                                                                </b-button>
                                                                <b-button
                                                                    v-if="puedeGestionarAsistentes && eventoid_seleccion1 && eventoid_seleccion1.asistentes && eventoid_seleccion1.asistentes.length"
                                                                    size="sm"
                                                                    variant="outline-success"
                                                                    class="ml-2"
                                                                    @click="descargarAsistentesExcel"
                                                                >
                                                                    <i class="bx bx-download mr-1"></i>Descargar Excel subido
                                                                </b-button>
                                                            </div>
                                                            <div v-if="asistentesYaCargados" class="alert alert-info py-2">
                                                                Este evento ya tiene una lista cargada. Solo se permite una carga por evento.
                                                            </div>
                                                            <div v-if="showUploadAsistentes && !asistentesYaCargados" class=" row mb-3">
                                                                <div class="offset-md-3  col-md-6">
                                                                    <b-form-file
                                                                        ref="asistentesFileInput"
                                                                        :key="asistentesFileKey"
                                                                        v-model="selectedAsistentesFile"
                                                                        class="form-control border-primary"
                                                                        accept=".xlsx,.xls,.csv"
                                                                        placeholder="Elegir Archivo"
                                                                        drop-placeholder="Arrastra el archivo aquí..."
                                                                        @change="onFileChange"
                                                                        browse-text="Examinar"
                                                                    ></b-form-file>
                                                                    <!-- <input type="file" @change="onFileChange" accept=".xlsx,.xls,.csv" /> -->
                                                                    <div class="mt-2">
                                                                        <b-button size="sm" variant="success" @click="uploadAsistentes" :disabled="!selectedAsistentesFile || isLoading">
                                                                            <b-spinner small class="mr-1" v-if="isLoading"></b-spinner>
                                                                            {{ isLoading ? 'Subiendo...' : 'Subir' }}
                                                                        </b-button>
                                                                        <b-button size="sm" variant="secondary" @click="toggleUploadAsistentes" :disabled="isLoading">Cancelar</b-button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-if="eventoid_seleccion1 && eventoid_seleccion1.asistentes && eventoid_seleccion1.asistentes.length">
                                                                <div class="table-responsive mb-0 mt-2">
                                                                    <table class="table table-hover">
                                                                        <thead>
                                                                            <tr>
                                                                                <th style="width: 5%;">Nº</th>
                                                                                <th style="width: 12%;">RUT</th>
                                                                                <th style="width: 24%;">Nombre</th>
                                                                                <th style="width: 12%;">Curso</th>
                                                                                <th style="width: 12%;">Celular</th>
                                                                                <th style="width: 18%;">Email</th>
                                                                                <th style="width: 17%;">Estado CRM</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(a, idx) in eventoid_seleccion1.asistentes" :key="idx">
                                                                                <td>{{ idx + 1 }}</td>
                                                                                <td>{{ a.rut || '-' }}</td>
                                                                                <td>{{ a.nombre || [a.nombres, a.apellido_paterno, a.apellido_materno].filter(Boolean).join(' ') || a.name || '-' }}</td>
                                                                                <td>{{ a.curso || '-' }}</td>
                                                                                <td>{{ a.celular || '-' }}</td>
                                                                                <td>{{ a.email || '-' }}</td>
                                                                                <td>
                                                                                    <span
                                                                                        class="badge"
                                                                                        :class="`badge-${crmEstadoBadge(a.estado_crm)}`"
                                                                                        :style="crmEstadoTooltip(a) ? { cursor: 'help' } : null"
                                                                                        :title="crmEstadoTooltip(a)"
                                                                                    >{{ crmEstadoTexto(a.estado_crm) }}</span>
                                                                                    <div v-if="a.reintentos_crm" class="small text-muted">Intentos: {{ a.reintentos_crm }}</div>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div v-else-if="!showUploadAsistentes && !asistentesYaCargados" class="text-center">
                                                                <p class="text-muted">No hay asistentes registrados para este evento.</p>
                                                                <div class="text-center mb-2">
                                                                    <b-button size="sm" variant="primary" @click="toggleUploadAsistentes">Cargar Asistentes</b-button>
                                                                </div>
                                                            </div>
                                                        </b-tab>
                                                        <b-tab v-if="puedeVerAsistentesQr" title="Asistentes QR" lazy>
                                                            <asistentesQrEvento
                                                                :evento-id="eventoid_seleccion1 && eventoid_seleccion1.id ? eventoid_seleccion1.id : null"
                                                                :evento-nombre="eventoid_seleccion1 && eventoid_seleccion1.nombre_difusion ? eventoid_seleccion1.nombre_difusion : ''"
                                                                :user="user"
                                                            />
                                                        </b-tab>
                                                        <b-tab v-if="puedeVerAsistentesQr" title="Asistentes CD" lazy>
                                                            <asistentesCdEvento
                                                                :evento-id="eventoid_seleccion1 && eventoid_seleccion1.id ? eventoid_seleccion1.id : null"
                                                                :evento-codigo="eventoid_seleccion1 && eventoid_seleccion1.codigo ? eventoid_seleccion1.codigo : ''"
                                                            />
                                                        </b-tab>
                                                        <b-tab title="Digitalizados">
                                                            <div v-if="digitalizadosEventoLista.length" class="table-responsive mb-0 mt-2">
                                                                <table class="table table-hover">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style="width: 5%;">Nº</th>
                                                                            <th style="width: 22%;">Digitalizador</th>
                                                                            <th style="width: 13%;">Estado</th>
                                                                            <th style="width: 10%;">Totales</th>
                                                                            <th style="width: 10%;">Revisadas</th>
                                                                            <th style="width: 10%;">Descartadas</th>
                                                                            <th style="width: 10%;">Faltantes</th>
                                                                            <th style="width: 10%;">Avance</th>
                                                                            <th style="width: 10%;">CRM</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item, idx) in digitalizadosEventoLista" :key="item.id || idx">
                                                                            <td>{{ idx + 1 }}</td>
                                                                            <td>{{ item.laborante ? item.laborante.name : '-' }}</td>
                                                                            <td>
                                                                                <span class="badge" :class="item.finalizada ? 'badge-success' : 'badge-warning'">
                                                                                    {{ item.finalizada ? 'Finalizado' : (item.estado || 'Activo') }}
                                                                                </span>
                                                                            </td>
                                                                            <td>{{ item.fichas_totales || 0 }}</td>
                                                                            <td>{{ item.fichas_revisadas || 0 }}</td>
                                                                            <td>{{ item.fichas_descartadas || 0 }}</td>
                                                                            <td>{{ item.fichas_faltantes || 0 }}</td>
                                                                            <td>{{ item.porcentaje_avance || 0 }}%</td>
                                                                            <td>{{ item.crm_exitosos || 0 }}/{{ item.crm_total_gestionable || 0 }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div v-else class="text-center text-muted py-2">
                                                                No hay digitalizaciones asociadas para este evento.
                                                            </div>
                                                        </b-tab>
                                                        <b-tab title="Comentarios" v-if="user.id==1">
                                                            <div class="form-group">
                                                                <label for="comentarioEvento">Nuevo comentario</label>
                                                                <textarea
                                                                    id="comentarioEvento"
                                                                    v-model="comentarioEventoNuevo"
                                                                    class="form-control"
                                                                    rows="4"
                                                                    maxlength="2000"
                                                                    placeholder="Escribe un comentario sobre la actividad del evento"
                                                                ></textarea>
                                                                <small :class="comentarioEventoCharsRestantes < 100 ? 'text-danger' : 'text-muted'">
                                                                    {{ comentarioEventoCharsRestantes }} caracteres restantes
                                                                </small>
                                                            </div>
                                                            <div class="mb-3">
                                                                <b-button
                                                                    variant="primary"
                                                                    @click="guardarComentarioEvento"
                                                                    :disabled="guardandoComentarioEvento || comentarioEventoCharsRestantes < 0 || !comentarioEventoNuevo.trim()"
                                                                >
                                                                    {{ guardandoComentarioEvento ? 'Guardando...' : 'Guardar comentario' }}
                                                                </b-button>
                                                            </div>

                                                            <div v-if="comentariosEvento.length > 0" class="table-responsive">
                                                                <table class="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Comentario</th>
                                                                            <th>Usuario</th>
                                                                            <th>Fecha</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="comentario in comentariosEvento" :key="comentario.id">
                                                                            <td style="white-space: pre-wrap;">{{ comentario.comentario }}</td>
                                                                            <td>{{ comentario.usuario_nombre || '-' }}</td>
                                                                            <td>{{ formatFechaHora(comentario.created_at) }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div v-else class="text-muted py-2">Aún no hay comentarios para este evento.</div>
                                                        </b-tab>
                                                    </b-tabs>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style>
.evento-detail-card {
    border-radius: 1rem;
    border: 1px solid #dde3ee;
    background: #f7f8fc;
    box-shadow: 0 18px 38px rgba(37, 44, 95, 0.08);
}

.evento-detail-body {
    padding: 1.5rem;
}

.evento-detail-topbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.9rem;
}

.evento-detail-back {
    border: 0;
    border-radius: 0.75rem;
    background: #cb9700;
    color: #fff;
    font-weight: 400;
    padding: 0.72rem 1.1rem;
    box-shadow: 0 12px 24px rgba(203, 151, 0, 0.24);
}

.evento-detail-back:hover,
.evento-detail-back:focus {
    background: #b98900;
    color: #fff;
}

.evento-detail-hero {
    margin-bottom: 1.25rem;
    padding: 1.35rem 1.35rem 1.15rem;
    border: 1px solid #e1e5ef;
    border-radius: 1rem;
    background: #fff;
}

.evento-detail-hero--ugm {
    padding: 0;
    border: 0;
    border-radius: 0.35rem;
    overflow: hidden;
    background: transparent;
    box-shadow: none;
}

.evento-detail-hero-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 0.9rem 1rem;
    border-radius: 0.25rem;
    background: linear-gradient(90deg, #b86a2f 0%, #cf7e3a 55%, #e5a35f 100%);
    box-shadow: 0 16px 30px rgba(201, 126, 55, 0.22);
}

.evento-detail-hero-bar__left {
    min-width: 0;
}

.evento-detail-hero-bar__title-row {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    margin-bottom: 0.28rem;
}

.evento-detail-hero-bar__icon {
    color: #fff;
    font-size: 1rem;
}

.evento-detail-hero-bar__title {
    margin: 0;
    color: #fff;
    font-size: 1.6rem;
    line-height: 1.1;
    font-weight: 800;
}

.evento-detail-hero-bar__meta {
    display: flex;
    gap: 0.55rem;
    align-items: center;
    flex-wrap: wrap;
    color: rgba(255, 255, 255, 0.92);
    font-size: 0.88rem;
    font-weight: 500;
}

.evento-detail-chip {
    display: inline-flex;
    align-items: center;
    padding: 0.12rem 0.45rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.18);
    color: #fff;
    font-size: 0.74rem;
    font-weight: 800;
}

.evento-detail-hero-bar__actions {
    display: flex;
    gap: 0.7rem;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.evento-detail-hero__eyebrow {
    display: inline-flex;
    align-items: center;
    padding: 0.3rem 0.7rem;
    margin-bottom: 0.95rem;
    border-radius: 999px;
    background: rgba(203, 151, 0, 0.12);
    color: #8b6800;
    font-size: 0.76rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.evento-detail-hero__main {
    display: flex;
    gap: 1rem;
    align-items: stretch;
}

.evento-detail-hero__accent {
    width: 6px;
    min-width: 6px;
    border-radius: 999px;
    background: #252c5f;
}

.evento-detail-hero__content {
    flex: 1;
}

.evento-detail-title {
    color: #252c5f;
    font-size: 2.05rem;
    line-height: 1.08;
    font-weight: 800;
    margin-bottom: 0.55rem !important;
}

.evento-detail-subtitle {
    color: #4f5b6b;
    font-size: 1.28rem;
    line-height: 1.2;
    font-weight: 700;
    margin-bottom: 0.85rem;
}

.evento-detail-meta {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.evento-detail-meta__item {
    min-width: 120px;
    padding: 0.72rem 0.85rem;
    border-radius: 0.85rem;
    background: #f5f7fb;
    border: 1px solid #e3e8f1;
}

.evento-detail-meta__label {
    display: block;
    color: #7b8494;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.2rem;
}

.evento-detail-meta__value {
    display: block;
    color: #252c5f;
    font-size: 1rem;
    font-weight: 800;
}

.evento-detail-readonly {
    align-items: stretch;
}

.evento-detail-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.25rem;
    padding: 0.95rem 1rem;
    border: 1px solid #e1e5ef;
    border-radius: 0.85rem;
    background: #fff;
    box-shadow: 0 10px 24px rgba(37, 44, 95, 0.04);
}

.evento-detail-toolbar--secondary {
    margin-top: -0.15rem;
    margin-bottom: 1rem;
}

.evento-detail-toolbar__left,
.evento-detail-toolbar__right {
    display: flex;
    gap: 0.65rem;
    align-items: center;
    flex-wrap: wrap;
}

.evento-detail-edit-actions {
    display: flex;
    gap: 0.6rem;
    align-items: center;
    flex-wrap: wrap;
}

.evento-detail-action-btn {
    border: 0;
    border-radius: 0.7rem;
    min-height: 42px;
    font-weight: 400;
    padding: 0.68rem 1rem;
    box-shadow: none !important;
}

.evento-detail-action-btn--subtle {
    min-height: 34px;
    padding: 0.45rem 0.8rem;
    border-radius: 0.6rem;
    font-size: 0.84rem;
    font-weight: 400;
}

.evento-detail-action-btn--gold {
    background: #cb9700;
    color: #fff;
}

.evento-detail-action-btn--gold:hover,
.evento-detail-action-btn--gold:focus {
    background: #b98900;
    color: #fff;
}

.evento-detail-action-btn--green {
    background: #2fbf7f;
    color: #fff;
}

.evento-detail-action-btn--green:hover,
.evento-detail-action-btn--green:focus {
    background: #28aa71;
    color: #fff;
}

.evento-detail-action-btn--dark {
    background: #252c5f;
    color: #fff;
}

.evento-detail-action-btn--dark:hover,
.evento-detail-action-btn--dark:focus {
    background: #1d234b;
    color: #fff;
}

.evento-detail-action-btn--white {
    background: #fff !important;
    color: #6f4423 !important;
    border: 1px solid rgba(111, 68, 35, 0.16) !important;
}

.evento-detail-action-btn--white:hover,
.evento-detail-action-btn--white:focus {
    background: #fff7f0 !important;
    color: #8a542c !important;
}

.evento-detail-action-btn--white i,
.evento-detail-action-btn--white span {
    color: inherit !important;
    opacity: 1 !important;
}

.evento-detail-hero-bar .evento-detail-action-btn {
    opacity: 1 !important;
}

.evento-detail-action-btn--muted {
    background: #eef1f7;
    color: #4e596a;
}

.evento-detail-action-btn--muted:hover,
.evento-detail-action-btn--muted:focus {
    background: #e3e8f1;
    color: #364152;
}

.evento-detail-action-btn--danger {
    background: #f76d6d;
    color: #fff;
}

.evento-detail-action-btn--danger:hover,
.evento-detail-action-btn--danger:focus {
    background: #ea5f5f;
    color: #fff;
}

.evento-detail-action-btn--icon {
    min-width: 46px;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
}

.evento-detail-action-btn--subtle.evento-detail-action-btn--icon {
    min-width: 34px;
    padding-left: 0.55rem;
    padding-right: 0.55rem;
}

.evento-detail-panel {
    height: 100%;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 1rem;
    box-shadow: 0 12px 28px rgba(33, 37, 41, 0.05);
    padding: 0;
    margin-bottom: 1rem;
}

.evento-detail-panel--ugm {
    overflow: hidden;
}

.evento-detail-panel__title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.9rem 1rem;
    background: #f8f9fa;
    color: #31384c;
    font-size: 0.92rem;
    font-weight: 800;
    letter-spacing: 0.01em;
}

.evento-detail-panel__title::before {
    content: '';
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background: #cb9700;
}

.evento-detail-table {
    display: table;
    width: 100%;
}

.evento-detail-table__row {
    display: table-row;
}

.evento-detail-table__label,
.evento-detail-table__value {
    display: table-cell;
    padding: 0.72rem 1rem;
    vertical-align: top;
    border-bottom: 1px dashed #e5e7eb;
    line-height: 1.45;
}

.evento-detail-table__label {
    width: 34%;
    color: #31384c;
    font-weight: 800;
}

.evento-detail-table__value {
    color: #596270;
}

.evento-detail-table__subvalue {
    font-size: 0.78rem;
    color: #8b93a1;
    margin-top: 0.1rem;
}

.evento-detail-table__row:last-child .evento-detail-table__label,
.evento-detail-table__row:last-child .evento-detail-table__value {
    border-bottom: 0;
}

.evento-detail-table__row--wrap .evento-detail-table__value {
    word-break: break-word;
}

.evento-detail-table__value--link {
    display: flex;
    align-items: flex-start;
    gap: 0.45rem;
    flex-wrap: wrap;
}

.evento-detail-tabs-wrap {
    margin-top: 0.5rem;
}

.evento-detail-tabs .nav-tabs {
    border-bottom: 1px solid #d7dce6;
    gap: 0.25rem;
}

.evento-detail-tabs .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.65rem;
    border-top-right-radius: 0.65rem;
    color: #5e6470;
    font-weight: 400;
    padding: 0.7rem 1rem;
}

.evento-detail-card .btn {
    font-weight: 400;
}

.evento-detail-tabs .nav-tabs .nav-link.active {
    color: #31384c;
    background: #fff;
    border-color: #d7dce6 #d7dce6 #fff;
    box-shadow: 0 -2px 0 0 #cb9700 inset;
}

.carga-documento-mejorada {
    border: 1px dashed #d8c1aa;
    border-radius: 0.5rem;
    padding: 1rem;
    background: #fcfaf7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    cursor: pointer;
}

.carga-documento-mejorada__acciones {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

@media (max-width: 767px) {
    .evento-detail-body {
        padding: 1rem;
    }

    .evento-detail-topbar {
        justify-content: stretch;
    }

    .evento-detail-back {
        width: 100%;
    }

    .evento-detail-title {
        font-size: 1.65rem;
    }

    .evento-detail-subtitle {
        font-size: 1.15rem;
    }

    .evento-detail-rbd {
        font-size: 1rem;
    }

    .evento-detail-toolbar {
        flex-direction: column;
        align-items: stretch;
        padding: 0.85rem;
    .evento-detail-hero {
        padding: 1rem;
    }

    .evento-detail-hero-bar {
        flex-direction: column;
        align-items: stretch;
        padding: 1rem;
    }

    .evento-detail-hero-bar__title {
        font-size: 1.3rem;
    }

    .evento-detail-hero-bar__actions {
        width: 100%;
    }

    .evento-detail-hero-bar__actions .btn {
        width: 100%;
    }

    .evento-detail-hero__main {
        gap: 0.8rem;
    }

    }

    .evento-detail-toolbar__left,

    .evento-detail-subtitle {
        font-size: 1.1rem;
    }

    .evento-detail-meta {
        flex-direction: column;
    }

    .evento-detail-meta__item {
        width: 100%;
    }
    .evento-detail-toolbar__right {
        width: 100%;
    }

    .evento-detail-toolbar__left .btn,
    .evento-detail-edit-actions .btn {
        width: 100%;
        margin-left: 0 !important;
        margin-top: 0.35rem;
    }

    .evento-detail-edit-actions {
        display: block;
        width: 100%;
    }

    .evento-detail-panel {
        border-radius: 0.85rem;
    }

    .evento-detail-table,
    .evento-detail-table__row,
    .evento-detail-table__label,
    .evento-detail-table__value {
        display: block;
        width: 100%;
    }

    .evento-detail-table__label {
        padding-bottom: 0.2rem;
        border-bottom: 0;
    }

    .evento-detail-table__value {
        padding-top: 0;
    }

    .evento-detail-table__value--link {
        flex-direction: column;
    }

    .evento-detail-tabs .nav-tabs {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
    }

    .carga-documento-mejorada {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
